// import { Component } from '@theme/component';
// import { fetchConfig, onAnimationEnd, preloadImage } from '@theme/utilities';
// import { ThemeEvents, CartAddEvent, CartErrorEvent, CartUpdateEvent, VariantUpdateEvent } from '@theme/events';
// import { cartPerformance } from '@theme/performance';
// import { morph } from '@theme/morph';

// export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;

// // Error message display duration - gives users time to read the message
// const ERROR_MESSAGE_DISPLAY_DURATION = 10000;

// // Button re-enable delay after error - prevents rapid repeat attempts
// const ERROR_BUTTON_REENABLE_DELAY = 1000;

// // Success message display duration for screen readers
// const SUCCESS_MESSAGE_DISPLAY_DURATION = 5000;

// /**
//  * A custom element that manages an add to cart button.
//  *
//  * @typedef {object} AddToCartRefs
//  * @property {HTMLButtonElement} addToCartButton - The add to cart button.
//  * @extends Component<AddToCartRefs>
//  */
// export class AddToCartComponent extends Component {
//   requiredRefs = ['addToCartButton'];

//   /** @type {number | undefined} */
//   #animationTimeout;

//   /** @type {number | undefined} */
//   #cleanupTimeout;

//   connectedCallback() {
//     super.connectedCallback();

//     this.addEventListener('pointerenter', this.#preloadImage);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);
//     this.removeEventListener('pointerenter', this.#preloadImage);
//   }

//   /**
//    * Disables the add to cart button.
//    */
//   disable() {
//     this.refs.addToCartButton.disabled = true;
//   }

//   /**
//    * Enables the add to cart button.
//    */
//   enable() {
//     this.refs.addToCartButton.disabled = false;
//   }

//   /**
//    * Handles the click event for the add to cart button.
//    * @param {MouseEvent & {target: HTMLElement}} event - The click event.
//    */
//   handleClick(event) {
//     const form = this.closest('form');
//     if (!form?.checkValidity()) return;

//     // Check if adding would exceed max before animating
//     const quantitySelector = /** @type {any} */ (form.querySelector('quantity-selector-component'));
//     if (quantitySelector?.canAddToCart) {
//       const validation = quantitySelector.canAddToCart();
//       // Don't animate if it would exceed max
//       if (!validation.canAdd) {
//         return;
//       }
//     }

//     this.animateAddToCart();

//     const animationEnabled = this.dataset.addToCartAnimation === 'true';

//     if (animationEnabled && !event.target.closest('.quick-add-modal')) {
//       this.#animateFlyToCart();
//     }
//   }

//   #preloadImage = () => {
//     const image = this.dataset.productVariantMedia;

//     if (!image) return;

//     preloadImage(image);
//   };

//   /**
//    * Animates the fly to cart animation.
//    */
//   #animateFlyToCart() {
//     const { addToCartButton } = this.refs;
//     const cartIcon = document.querySelector('.header-actions__cart-icon');

//     const image = this.dataset.productVariantMedia;

//     if (!cartIcon || !addToCartButton || !image) return;

//     const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

//     flyToCartElement.style.setProperty('background-image', `url(${image})`);
//     flyToCartElement.source = addToCartButton;
//     flyToCartElement.destination = cartIcon;

//     document.body.appendChild(flyToCartElement);
//   }

//   /**
//    * Animates the add to cart button.
//    */
//   animateAddToCart() {
//     const { addToCartButton } = this.refs;

//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);

//     if (!addToCartButton.classList.contains('atc-added')) {
//       addToCartButton.classList.add('atc-added');
//     }

//     this.#animationTimeout = setTimeout(() => {
//       this.#cleanupTimeout = setTimeout(() => {
//         this.refs.addToCartButton.classList.remove('atc-added');
//       }, 10);
//     }, ADD_TO_CART_TEXT_ANIMATION_DURATION);
//   }
// }

// if (!customElements.get('add-to-cart-component')) {
//   customElements.define('add-to-cart-component', AddToCartComponent);
// }

// /**
//  * A custom element that manages a product form.
//  *
//  * @typedef {object} ProductFormRefs
//  * @property {HTMLInputElement} variantId - The form input for submitting the variant ID.
//  * @property {AddToCartComponent | undefined} addToCartButtonContainer - The add to cart button container element.
//  * @property {HTMLElement | undefined} addToCartTextError - The add to cart text error.
//  * @property {HTMLElement | undefined} acceleratedCheckoutButtonContainer - The accelerated checkout button container element.
//  * @property {HTMLElement} liveRegion - The live region.
//  * @property {HTMLElement | undefined} quantityLabelCartCount - The quantity label cart count element.
//  * @property {HTMLElement | undefined} quantityRules - The quantity rules element.
//  * @property {HTMLElement | undefined} productFormButtons - The product form buttons container.
//  *
//  * @extends Component<ProductFormRefs>
//  */
// class ProductFormComponent extends Component {
//   requiredRefs = ['variantId', 'liveRegion'];
//   #abortController = new AbortController();

//   /** @type {number | undefined} */
//   #timeout;

//   connectedCallback() {
//     super.connectedCallback();

//     const { signal } = this.#abortController;
//     const target = this.closest('.shopify-section, dialog, product-card');
//     target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
//     target?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected, { signal });

//     // Listen for cart updates to sync data-cart-quantity
//     document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate, { signal });
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     this.#abortController.abort();
//   }

//   /**
//    * Fetches cart and updates quantity selector for current variant
//    * @returns {Promise<number>} The cart quantity for the current variant
//    */
//   async #fetchAndUpdateCartQuantity() {
//     const variantIdInput = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="id"]'));
//     if (!variantIdInput?.value) return 0;

//     try {
//       const response = await fetch('/cart.js');
//       const cart = await response.json();

//       const cartItem = cart.items.find(
//         /** @param {any} item */
//         (item) => item.variant_id.toString() === variantIdInput.value.toString()
//       );
//       const cartQty = cartItem ? cartItem.quantity : 0;

//       // Use public API to update quantity selector
//       const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//       if (quantitySelector?.setCartQuantity) {
//         quantitySelector.setCartQuantity(cartQty);
//       }

//       // Update quantity label if it exists
//       this.#updateQuantityLabel(cartQty);

//       return cartQty;
//     } catch (error) {
//       console.error('Failed to fetch cart quantity:', error);
//       return 0;
//     }
//   }

//   /**
//    * Updates data-cart-quantity when cart is updated from elsewhere
//    * @param {CartUpdateEvent|CartAddEvent} event
//    */
//   #onCartUpdate = async (event) => {
//     // Skip if this event came from this component
//     if (event.detail?.sourceId === this.id || event.detail?.data?.source === 'product-form-component') return;

//     await this.#fetchAndUpdateCartQuantity();
//   };

//   /**
//    * Handles the submit event for the product form.
//    *
//    * @param {Event} event - The submit event.
//    */
//   handleSubmit(event) {
//     const { addToCartTextError, addToCartButtonContainer } = this.refs;
//     // Stop default behaviour from the browser
//     event.preventDefault();

//     if (this.#timeout) clearTimeout(this.#timeout);

//     // Check if the add to cart button is disabled and do an early return if it is
//     if (addToCartButtonContainer?.refs.addToCartButton?.disabled) return;

//     // Send the add to cart information to the cart
//     const form = this.querySelector('form');

//     if (!form) throw new Error('Product form element missing');

//     const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//     if (quantitySelector?.canAddToCart) {
//       const validation = quantitySelector.canAddToCart();

//       if (!validation.canAdd) {
//         addToCartButtonContainer?.disable();

//         const errorTemplate = this.dataset.quantityErrorMax || '';
//         const errorMessage = errorTemplate.replace('{{ maximum }}', validation.maxQuantity.toString());
//         if (addToCartTextError) {
//           addToCartTextError.classList.remove('hidden');

//           const textNode = addToCartTextError.childNodes[2];
//           if (textNode) {
//             textNode.textContent = errorMessage;
//           } else {
//             const newTextNode = document.createTextNode(errorMessage);
//             addToCartTextError.appendChild(newTextNode);
//           }

//           this.#setLiveRegionText(errorMessage);

//           if (this.#timeout) clearTimeout(this.#timeout);
//           this.#timeout = setTimeout(() => {
//             if (!addToCartTextError) return;
//             addToCartTextError.classList.add('hidden');
//             this.#clearLiveRegionText();
//           }, ERROR_MESSAGE_DISPLAY_DURATION);
//         }

//         setTimeout(() => {
//           addToCartButtonContainer?.enable();
//         }, ERROR_BUTTON_REENABLE_DELAY);

//         return;
//       }
//     }

//     const formData = new FormData(form);

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     let cartItemComponentsSectionIds = [];
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         cartItemComponentsSectionIds.push(item.dataset.sectionId);
//       }
//       formData.append('sections', cartItemComponentsSectionIds.join(','));
//     });

//     const fetchCfg = fetchConfig('javascript', { body: formData });

//     fetch(Theme.routes.cart_add_url, {
//       ...fetchCfg,
//       headers: {
//         ...fetchCfg.headers,
//         Accept: 'text/html',
//       },
//     })
//       .then((response) => response.json())
//       .then((response) => {
//         if (response.status) {
//           this.dispatchEvent(
//             new CartErrorEvent(form.getAttribute('id') || '', response.message, response.description, response.errors)
//           );

//           if (!addToCartTextError) return;
//           addToCartTextError.classList.remove('hidden');

//           // Reuse the text node if the user is spam-clicking
//           const textNode = addToCartTextError.childNodes[2];
//           if (textNode) {
//             textNode.textContent = response.message;
//           } else {
//             const newTextNode = document.createTextNode(response.message);
//             addToCartTextError.appendChild(newTextNode);
//           }

//           // Create or get existing error live region for screen readers
//           this.#setLiveRegionText(response.message);

//           this.#timeout = setTimeout(() => {
//             if (!addToCartTextError) return;
//             addToCartTextError.classList.add('hidden');

//             // Clear the announcement
//             this.#clearLiveRegionText();
//           }, ERROR_MESSAGE_DISPLAY_DURATION);

//           // When we add more than the maximum amount of items to the cart, we need to dispatch a cart update event
//           // because our back-end still adds the max allowed amount to the cart.
//           this.dispatchEvent(
//             new CartAddEvent({}, this.id, {
//               didError: true,
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//             })
//           );

//           return;
//         } else {
//           const id = formData.get('id');

//           if (addToCartTextError) {
//             addToCartTextError.classList.add('hidden');
//             addToCartTextError.removeAttribute('aria-live');
//           }

//           if (!id) throw new Error('Form ID is required');

//           // Add aria-live region to inform screen readers that the item was added
//           if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
//             const addToCartButton = this.refs.addToCartButtonContainer.refs.addToCartButton;
//             const addedTextElement = addToCartButton.querySelector('.add-to-cart-text--added');
//             const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;

//             this.#setLiveRegionText(addedText);

//             setTimeout(() => {
//               this.#clearLiveRegionText();
//             }, SUCCESS_MESSAGE_DISPLAY_DURATION);
//           }

//           // Fetch the updated cart to get the actual total quantity for this variant
//           this.#fetchAndUpdateCartQuantity();

//           this.dispatchEvent(
//             new CartAddEvent({}, id.toString(), {
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//               sections: response.sections,
//             })
//           );
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         cartPerformance.measureFromEvent('add:user-action', event);
//       });
//   }

//   /**
//    * Updates the quantity label with the current cart quantity
//    * @param {number} cartQty - The quantity in cart
//    */
//   #updateQuantityLabel(cartQty) {
//     const quantityLabel = this.refs.quantityLabelCartCount;
//     if (quantityLabel) {
//       const inCartText = quantityLabel.textContent?.match(/\((\d+)\s+(.+)\)/);
//       if (inCartText && inCartText[2]) {
//         quantityLabel.textContent = `(${cartQty} ${inCartText[2]})`;
//       }

//       // Show/hide based on quantity
//       quantityLabel.classList.toggle('hidden', cartQty === 0);
//     }
//   }

//   /**
//    * @param {*} text
//    */
//   #setLiveRegionText(text) {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = text;
//   }

//   #clearLiveRegionText() {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = '';
//   }

//   /**
//    * Morphs or removes/adds an element based on current and new element states
//    * @param {Element | null | undefined} currentElement - The current element in the DOM
//    * @param {Element | null | undefined} newElement - The new element from the server response
//    * @param {Element | null} [insertReferenceElement] - Element to insert before if adding new element
//    */
//   #morphOrUpdateElement(currentElement, newElement, insertReferenceElement = null) {
//     if (currentElement && newElement) {
//       morph(currentElement, newElement);
//     } else if (currentElement && !newElement) {
//       currentElement.remove();
//     } else if (!currentElement && newElement && insertReferenceElement) {
//       insertReferenceElement.insertAdjacentElement('beforebegin', /** @type {Element} */ (newElement.cloneNode(true)));
//     }
//   }

//   /**
//    * @param {VariantUpdateEvent} event
//    */
//   #onVariantUpdate = async (event) => {
//     if (event.detail.data.newProduct) {
//       this.dataset.productId = event.detail.data.newProduct.id;
//     } else if (event.detail.data.productId !== this.dataset.productId) {
//       return;
//     }

//     const { variantId, addToCartButtonContainer } = this.refs;

//     const currentAddToCartButton = addToCartButtonContainer?.refs.addToCartButton;
//     const newAddToCartButton = event.detail.data.html.querySelector('[ref="addToCartButton"]');

//     // Update the variant ID
//     variantId.value = event.detail.resource?.id ?? '';

//     if (!currentAddToCartButton && !this.refs.acceleratedCheckoutButtonContainer) return;

//     // Update the button state
//     if (currentAddToCartButton) {
//       if (event.detail.resource == null || event.detail.resource.available == false) {
//         addToCartButtonContainer.disable();
//       } else {
//         addToCartButtonContainer.enable();
//       }

//       // Update the add to cart button text and icon
//       if (newAddToCartButton) {
//         morph(currentAddToCartButton, newAddToCartButton);
//       }
//     }

//     if (this.refs.acceleratedCheckoutButtonContainer) {
//       if (event.detail.resource == null || event.detail.resource.available == false) {
//         this.refs.acceleratedCheckoutButtonContainer?.setAttribute('hidden', 'true');
//       } else {
//         this.refs.acceleratedCheckoutButtonContainer?.removeAttribute('hidden');
//       }
//     }

//     // Set the data attribute for the add to cart button to the product variant media if it exists
//     if (event.detail.resource) {
//       const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
//       productVariantMedia &&
//         addToCartButtonContainer?.setAttribute('data-product-variant-media', productVariantMedia + '&width=100');
//     }

//     // Update quantity selector's min/max/step attributes and cart quantity for the new variant
//     const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//     const newQuantityInput = /** @type {HTMLInputElement | null} */ (
//       event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
//     );

//     if (quantitySelector?.updateConstraints && newQuantityInput) {
//       quantitySelector.updateConstraints(
//         newQuantityInput.min,
//         newQuantityInput.max || null,
//         newQuantityInput.step
//       );
//     }

//     // Check if quantity rules are appearing/disappearing (causes layout shift)
//     const quantityRules = this.refs.quantityRules;
//     const newQuantityRules = event.detail.data.html.querySelector('.quantity-rules');
//     const isQuantityRulesChanging = !!quantityRules !== !!newQuantityRules;

//     if (isQuantityRulesChanging && quantitySelector) {
//       // Store quantity value before morphing entire container
//       const currentQuantityValue = quantitySelector.getValue?.();

//       const currentProductFormButtons = this.refs.productFormButtons;
//       const newProductFormButtons = event.detail.data.html.querySelector('.product-form-buttons');

//       if (currentProductFormButtons && newProductFormButtons) {
//         morph(currentProductFormButtons, newProductFormButtons);

//         // Get the NEW quantity selector after morphing and update its constraints
//         const newQuantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//         const newQuantityInputElement = /** @type {HTMLInputElement | null} */ (
//           event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
//         );

//         if (newQuantitySelector?.updateConstraints && newQuantityInputElement && currentQuantityValue) {
//           // Temporarily set the old value so updateConstraints can snap it properly
//           newQuantitySelector.setValue(currentQuantityValue);
//           // updateConstraints will snap to valid increment if needed
//           newQuantitySelector.updateConstraints(
//             newQuantityInputElement.min,
//             newQuantityInputElement.max || null,
//             newQuantityInputElement.step
//           );
//         }
//       }
//     } else {
//       // Update elements individually when layout isn't changing
//       const quantityLabel = this.querySelector('.quantity-label');
//       const newQuantityLabel = event.detail.data.html.querySelector('.quantity-label');
//       this.#morphOrUpdateElement(quantityLabel, newQuantityLabel, quantitySelector);

//       const addToCartButton = this.querySelector('[ref="addToCartButtonContainer"]');
//       this.#morphOrUpdateElement(quantityRules, newQuantityRules, addToCartButton);
//     }

//     // Fetch and update cart quantity for the new variant
//     await this.#fetchAndUpdateCartQuantity();
//   };

//   /**
//    * Disable the add to cart button while the UI is updating before #onVariantUpdate is called.
//    * Accelerated checkout button is also disabled via its own event listener not exposed to the theme.
//    */
//   #onVariantSelected = () => {
//     this.refs.addToCartButtonContainer?.disable();
//   };
// }

// if (!customElements.get('product-form-component')) {
//   customElements.define('product-form-component', ProductFormComponent);
// }

// class FlyToCart extends HTMLElement {
//   /** @type {Element} */
//   source;

//   /** @type {Element} */
//   destination;

//   connectedCallback() {
//     this.#animate();
//   }

//   #animate() {
//     const rect = this.getBoundingClientRect();
//     const sourceRect = this.source.getBoundingClientRect();
//     const destinationRect = this.destination.getBoundingClientRect();

//     //Define bezier curve points
//     // Maybe add half of the size of the flying thingy to the x and y to make it center properly
//     const offset = {
//       x: rect.width / 2,
//       y: rect.height / 2,
//     };
//     const startPoint = {
//       x: sourceRect.left + sourceRect.width / 2 - offset.x,
//       y: sourceRect.top + sourceRect.height / 2 - offset.y,
//     };

//     const endPoint = {
//       x: destinationRect.left + destinationRect.width / 2 - offset.x,
//       y: destinationRect.top + destinationRect.height / 2 - offset.y,
//     };

//     //Calculate the control points
//     const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 }; // Go up 200px
//     const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 }; // Go left 300px and up 100px

//     //Animation variables
//     /** @type {number | null} */
//     let startTime = null;
//     const duration = 600; // 600ms

//     this.style.opacity = '1';

//     /**
//      * Animates the flying thingy along the bezier curve.
//      * @param {number} currentTime - The current time.
//      */
//     const animate = (currentTime) => {
//       if (!startTime) startTime = currentTime;
//       const elapsed = currentTime - startTime;
//       const progress = Math.min(elapsed / duration, 1);

//       // Calculate current position along the bezier curve
//       const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

//       //Update the position of the flying thingy
//       this.style.setProperty('--x', `${position.x}px`);
//       this.style.setProperty('--y', `${position.y}px`);

//       // Scale down as it approaches the cart
//       const scale = 1 - progress * 0.5;
//       this.style.setProperty('--scale', `${scale}`);

//       //Continue the animation if not finished
//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         //Fade out the flying thingy
//         this.style.opacity = '0';
//         onAnimationEnd(this, () => this.remove());
//       }
//     };

//     // Position the flying thingy back to the start point
//     this.style.setProperty('--x', `${startPoint.x}px`);
//     this.style.setProperty('--y', `${startPoint.y}px`);

//     //Start the animation
//     requestAnimationFrame(animate);
//   }
// }

// /**
//  * Calculates a point on a cubic Bézier curve.
//  * @param {number} t - The parameter value (0 <= t <= 1).
//  * @param {{x: number, y: number}} p0 - The starting point (x, y).
//  * @param {{x: number, y: number}} p1 - The first control point (x, y).
//  * @param {{x: number, y: number}} p2 - The second control point (x, y).
//  * @param {{x: number, y: number}} p3 - The ending point (x, y).
//  * @returns {{x: number, y: number}} The point on the curve.
//  */
// function bezierPoint(t, p0, p1, p2, p3) {
//   const cX = 3 * (p1.x - p0.x);
//   const bX = 3 * (p2.x - p1.x) - cX;
//   const aX = p3.x - p0.x - cX - bX;

//   const cY = 3 * (p1.y - p0.y);
//   const bY = 3 * (p2.y - p1.y) - cY;
//   const aY = p3.y - p0.y - cY - bY;

//   const x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x;
//   const y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y;

//   return { x, y };
// }

// if (!customElements.get('fly-to-cart')) {
//   customElements.define('fly-to-cart', FlyToCart);
// }
// ################################以下是飞入1.0########################################################################

// import { Component } from '@theme/component';
// import { fetchConfig, onAnimationEnd, preloadImage } from '@theme/utilities';
// import { ThemeEvents, CartAddEvent, CartErrorEvent, CartUpdateEvent, VariantUpdateEvent } from '@theme/events';
// import { cartPerformance } from '@theme/performance';
// import { morph } from '@theme/morph';

// export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;

// // Error message display duration - gives users time to read the message
// const ERROR_MESSAGE_DISPLAY_DURATION = 10000;

// // Button re-enable delay after error - prevents rapid repeat attempts
// const ERROR_BUTTON_REENABLE_DELAY = 1000;

// // Success message display duration for screen readers
// const SUCCESS_MESSAGE_DISPLAY_DURATION = 5000;

// // =========================
// // 自定义：购物车徽标与飞入动画配置
// // =========================
// const CUSTOM_CART_COUNT_STORAGE_KEY = 'custom_cart_click_count_v2';
// const CUSTOM_CART_ICON_SELECTORS = [
//   '.header-actions__cart-icon',
//   '#cart-icon-bubble',
//   '.header__icon--cart',
//   'cart-drawer-opener',
//   'a[href="/cart"]',
//   'a[href*="/cart"]',
//   '[data-cart-icon]',
//   '.site-header__cart',
//   '.header__cart',
//   '.header a[href="/cart"]',
//   '.header a[href*="/cart"]',
// ];

// let customLastAddToCartSourceElement = null;
// let customLastAddToCartSourceRect = null;
// let customCartAnimationLock = false;
// let customCartAnimationUnlockTimer = null;
// let customCartUiInitialized = false;

// // 新增：防止一次加购成功被重复处理
// let customLastSuccessSignature = '';
// let customLastSuccessAt = 0;

// /**
//  * 获取 localStorage 数量
//  * @returns {number}
//  */
// function getCustomStoredCartCount() {
//   try {
//     const raw = localStorage.getItem(CUSTOM_CART_COUNT_STORAGE_KEY);
//     const num = parseInt(raw || '0', 10);
//     return Number.isNaN(num) ? 0 : Math.max(0, num);
//   } catch (e) {
//     return 0;
//   }
// }

// /**
//  * 设置 localStorage 数量
//  * @param {number} value
//  */
// function setCustomStoredCartCount(value) {
//   try {
//     localStorage.setItem(CUSTOM_CART_COUNT_STORAGE_KEY, String(Math.max(0, value)));
//   } catch (e) {}
// }

// /**
//  * 增加 localStorage 数量
//  * @param {number} step
//  * @returns {number}
//  */
// function incrementCustomStoredCartCount(step = 1) {
//   const current = getCustomStoredCartCount();
//   const next = current + Math.max(1, step);
//   setCustomStoredCartCount(next);
//   return next;
// }

// /**
//  * 清空 localStorage 数量
//  */
// function clearCustomStoredCartCount() {
//   try {
//     localStorage.removeItem(CUSTOM_CART_COUNT_STORAGE_KEY);
//   } catch (e) {}
// }

// /**
//  * 是否购物车页
//  * @returns {boolean}
//  */
// function isCustomCartPage() {
//   return window.location.pathname === '/cart';
// }

// /**
//  * 获取所有购物车 icon
//  * @returns {Element[]}
//  */
// function getAllCustomCartIcons() {
//   const found = [];
//   const seen = new Set();

//   CUSTOM_CART_ICON_SELECTORS.forEach((selector) => {
//     document.querySelectorAll(selector).forEach((el) => {
//       if (!seen.has(el)) {
//         seen.add(el);
//         found.push(el);
//       }
//     });
//   });

//   return found;
// }

// /**
//  * 获取当前可见购物车 icon
//  * @returns {Element | null}
//  */
// function getVisibleCustomCartIcon() {
//   const icons = getAllCustomCartIcons();
//   const visible = icons.find((el) => {
//     const rect = el.getBoundingClientRect();
//     return rect.width > 0 && rect.height > 0;
//   });
//   return visible || icons[0] || null;
// }

// /**
//  * 获取或创建购物车徽标
//  * @param {Element} cartIcon
//  * @returns {HTMLElement | null}
//  */
// function getOrCreateCustomCartBadge(cartIcon) {
//   if (!(cartIcon instanceof HTMLElement)) return null;

//   cartIcon.classList.add('cart-icon-badge-anchor');

//   let badge = cartIcon.querySelector('.cart-count-badge--custom');
//   if (!badge) {
//     badge = document.createElement('span');
//     badge.className = 'cart-count-badge--custom is-hidden';
//     badge.setAttribute('aria-hidden', 'true');
//     badge.textContent = '0';
//     cartIcon.appendChild(badge);
//   }

//   return /** @type {HTMLElement} */ (badge);
// }

// /**
//  * 更新所有购物车徽标
//  * @param {number} count
//  */
// function updateAllCustomCartBadges(count) {
//   const icons = getAllCustomCartIcons();
//   icons.forEach((icon) => {
//     const badge = getOrCreateCustomCartBadge(icon);
//     if (!badge) return;

//     badge.textContent = count > 99 ? '99+' : String(count);

//     if (count > 0) {
//       badge.classList.remove('is-hidden');
//     } else {
//       badge.classList.add('is-hidden');
//     }
//   });
// }

// /**
//  * 从 localStorage 同步徽标
//  */
// function syncCustomCartBadgesFromStorage() {
//   updateAllCustomCartBadges(getCustomStoredCartCount());
// }

// /**
//  * 清空徽标显示
//  */
// function clearCustomCartBadgesImmediately() {
//   updateAllCustomCartBadges(0);
// }

// /**
//  * 购物车图标抖动
//  * @param {Element | null} cartIcon
//  */
// function bounceCustomCartIcon(cartIcon) {
//   if (!(cartIcon instanceof HTMLElement)) return;

//   cartIcon.classList.remove('cart-icon-bounce');
//   void cartIcon.offsetWidth;
//   cartIcon.classList.add('cart-icon-bounce');

//   setTimeout(() => {
//     cartIcon.classList.remove('cart-icon-bounce');
//   }, 700);
// }

// /**
//  * 确保样式只注入一次
//  */
// function ensureCustomCartUiStyles() {
//   if (document.getElementById('custom-cart-badge-styles')) return;

//   const style = document.createElement('style');
//   style.id = 'custom-cart-badge-styles';
//   style.textContent = `
//     .cart-icon-badge-anchor {
//       position: relative !important;
//       overflow: visible !important;
//     }

//     .cart-count-badge--custom {
//       position: absolute;
//       top: -8px;
//       right: -12px;
//       min-width: 22px;
//       height: 22px;
//       padding: 0 6px;
//       border-radius: 999px;
//       background: #e3a23a;
//       color: #fff;
//       font-size: 12px;
//       line-height: 22px;
//       font-weight: 700;
//       text-align: center;
//       white-space: nowrap;
//       box-shadow: 0 4px 10px rgba(227, 162, 58, 0.28);
//       border: 2px solid #fff;
//       z-index: 999;
//       pointer-events: none;
//     }

//     .cart-count-badge--custom.is-hidden {
//       display: none;
//     }

//     .cart-icon-bounce {
//       animation: cartIconBounce 0.62s ease;
//     }

//     @keyframes cartIconBounce {
//       0% { transform: scale(1); }
//       25% { transform: scale(1.16); }
//       50% { transform: scale(0.94); }
//       75% { transform: scale(1.08); }
//       100% { transform: scale(1); }
//     }

//     @media (max-width: 749px) {
//       .cart-count-badge--custom {
//         top: -6px;
//         right: -10px;
//       }
//     }
//   `;
//   document.head.appendChild(style);
// }

// /**
//  * 初始化购物车 UI 事件
//  */
// function initializeCustomCartUiOnce() {
//   if (customCartUiInitialized) return;
//   customCartUiInitialized = true;

//   ensureCustomCartUiStyles();

//   if (isCustomCartPage()) {
//     clearCustomStoredCartCount();
//     clearCustomCartBadgesImmediately();
//   } else {
//     syncCustomCartBadgesFromStorage();
//     setTimeout(syncCustomCartBadgesFromStorage, 300);
//     setTimeout(syncCustomCartBadgesFromStorage, 1200);
//   }

//   document.addEventListener(
//     'click',
//     (event) => {
//       const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
//       if (!target) return;

//       const cartHit = target.closest(CUSTOM_CART_ICON_SELECTORS.join(', '));

//       if (cartHit) {
//         clearCustomStoredCartCount();
//         clearCustomCartBadgesImmediately();
//       }
//     },
//     true
//   );

//   window.addEventListener('storage', (event) => {
//     if (event.key === CUSTOM_CART_COUNT_STORAGE_KEY) {
//       if (isCustomCartPage()) {
//         clearCustomStoredCartCount();
//         clearCustomCartBadgesImmediately();
//       } else {
//         syncCustomCartBadgesFromStorage();
//       }
//     }
//   });

//   document.addEventListener('shopify:section:load', () => {
//     setTimeout(syncCustomCartBadgesFromStorage, 100);
//   });

//   document.addEventListener('shopify:section:reorder', () => {
//     setTimeout(syncCustomCartBadgesFromStorage, 100);
//   });

//   document.addEventListener('shopify:block:select', () => {
//     setTimeout(syncCustomCartBadgesFromStorage, 100);
//   });
// }

// /**
//  * 从 source 飞向 cart
//  * @param {Element | null | undefined} source
//  * @param {Element | null | undefined} destination
//  */
// function runCustomFlyToCart(source, destination) {
//   const cartIcon = destination || getVisibleCustomCartIcon();

//   if (!cartIcon) {
//     return;
//   }

//   // 正在飞时，不再新建第二个动画，避免一次点按飞两次
//   if (customCartAnimationLock) {
//     bounceCustomCartIcon(cartIcon);
//     return;
//   }

//   const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

//   if (source instanceof Element) {
//     flyToCartElement.source = source;
//   }

//   if (customLastAddToCartSourceRect) {
//     flyToCartElement.sourceRect = customLastAddToCartSourceRect;
//   }

//   flyToCartElement.destination = cartIcon;
//   document.body.appendChild(flyToCartElement);
// }

// /**
//  * 加购成功后的统一处理
//  * @param {number} quantityToAdd
//  * @param {Element | null | undefined} sourceElement
//  * @param {string} variantId
//  */
// function handleCustomAddSuccess(quantityToAdd, sourceElement, variantId = '') {
//   initializeCustomCartUiOnce();

//   // 对同一次加购成功做去重
//   const now = Date.now();
//   const rect = customLastAddToCartSourceRect;
//   const rectKey = rect
//     ? `${Math.round(rect.left)}-${Math.round(rect.top)}-${Math.round(rect.width)}-${Math.round(rect.height)}`
//     : 'no-rect';

//   const successSignature = `${variantId || 'no-variant'}|${quantityToAdd}|${rectKey}`;

//   // 450ms 内同签名视为同一次成功回调，直接忽略
//   if (customLastSuccessSignature === successSignature && now - customLastSuccessAt < 450) {
//     return;
//   }

//   customLastSuccessSignature = successSignature;
//   customLastSuccessAt = now;

//   const nextCount = incrementCustomStoredCartCount(quantityToAdd);
//   updateAllCustomCartBadges(nextCount);

//   const cartIcon = getVisibleCustomCartIcon();
//   runCustomFlyToCart(sourceElement || customLastAddToCartSourceElement, cartIcon);

//   setTimeout(syncCustomCartBadgesFromStorage, 120);
//   setTimeout(syncCustomCartBadgesFromStorage, 400);
//   setTimeout(syncCustomCartBadgesFromStorage, 900);
// }

// /**
//  * A custom element that manages an add to cart button.
//  *
//  * @typedef {object} AddToCartRefs
//  * @property {HTMLButtonElement} addToCartButton - The add to cart button.
//  * @extends Component<AddToCartRefs>
//  */
// export class AddToCartComponent extends Component {
//   requiredRefs = ['addToCartButton'];

//   /** @type {number | undefined} */
//   #animationTimeout;

//   /** @type {number | undefined} */
//   #cleanupTimeout;

//   connectedCallback() {
//     super.connectedCallback();

//     this.addEventListener('pointerenter', this.#preloadImage);
//     this.addEventListener('pointerdown', this.#rememberSource, true);

//     initializeCustomCartUiOnce();
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);
//     this.removeEventListener('pointerenter', this.#preloadImage);
//     this.removeEventListener('pointerdown', this.#rememberSource, true);
//   }

//   /**
//    * Disables the add to cart button.
//    */
//   disable() {
//     this.refs.addToCartButton.disabled = true;
//   }

//   /**
//    * Enables the add to cart button.
//    */
//   enable() {
//     this.refs.addToCartButton.disabled = false;
//   }

//   /**
//    * 记录最近一次点击源按钮
//    * @param {PointerEvent} event
//    */
//   #rememberSource = (event) => {
//     const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
//     if (!target) return;

//     const button =
//       target.closest('button') ||
//       this.refs.addToCartButton ||
//       this;

//     customLastAddToCartSourceElement = button;

//     if (button instanceof Element) {
//       const rect = button.getBoundingClientRect();
//       customLastAddToCartSourceRect = {
//         left: rect.left,
//         top: rect.top,
//         width: rect.width,
//         height: rect.height,
//       };
//     }
//   };

//   /**
//    * Handles the click event for the add to cart button.
//    * @param {MouseEvent & {target: HTMLElement}} event - The click event.
//    */
//   handleClick(event) {
//     const form = this.closest('form');
//     if (!form?.checkValidity()) return;

//     // Check if adding would exceed max before animating
//     const quantitySelector = /** @type {any} */ (form.querySelector('quantity-selector-component'));
//     if (quantitySelector?.canAddToCart) {
//       const validation = quantitySelector.canAddToCart();
//       // Don't animate if it would exceed max
//       if (!validation.canAdd) {
//         return;
//       }
//     }

//     // 这里只保留按钮文字动画，不再在点击时直接飞入
//     this.animateAddToCart();

//     // 记录最近点击源，真正飞入改到加购成功后
//     customLastAddToCartSourceElement =
//       event.target.closest('button') ||
//       this.refs.addToCartButton ||
//       this;

//     if (customLastAddToCartSourceElement instanceof Element) {
//       const rect = customLastAddToCartSourceElement.getBoundingClientRect();
//       customLastAddToCartSourceRect = {
//         left: rect.left,
//         top: rect.top,
//         width: rect.width,
//         height: rect.height,
//       };
//     }
//   }

//   #preloadImage = () => {
//     const image = this.dataset.productVariantMedia;

//     if (!image) return;

//     preloadImage(image);
//   };

//   /**
//    * Animates the add to cart button.
//    */
//   animateAddToCart() {
//     const { addToCartButton } = this.refs;

//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);

//     if (!addToCartButton.classList.contains('atc-added')) {
//       addToCartButton.classList.add('atc-added');
//     }

//     this.#animationTimeout = setTimeout(() => {
//       this.#cleanupTimeout = setTimeout(() => {
//         this.refs.addToCartButton.classList.remove('atc-added');
//       }, 10);
//     }, ADD_TO_CART_TEXT_ANIMATION_DURATION);
//   }
// }

// if (!customElements.get('add-to-cart-component')) {
//   customElements.define('add-to-cart-component', AddToCartComponent);
// }

// /**
//  * A custom element that manages a product form.
//  *
//  * @typedef {object} ProductFormRefs
//  * @property {HTMLInputElement} variantId - The form input for submitting the variant ID.
//  * @property {AddToCartComponent | undefined} addToCartButtonContainer - The add to cart button container element.
//  * @property {HTMLElement | undefined} addToCartTextError - The add to cart text error.
//  * @property {HTMLElement | undefined} acceleratedCheckoutButtonContainer - The accelerated checkout button container element.
//  * @property {HTMLElement} liveRegion - The live region.
//  * @property {HTMLElement | undefined} quantityLabelCartCount - The quantity label cart count element.
//  * @property {HTMLElement | undefined} quantityRules - The quantity rules element.
//  * @property {HTMLElement | undefined} productFormButtons - The product form buttons container.
//  *
//  * @extends Component<ProductFormRefs>
//  */
// class ProductFormComponent extends Component {
//   requiredRefs = ['variantId', 'liveRegion'];
//   #abortController = new AbortController();

//   /** @type {number | undefined} */
//   #timeout;

//   connectedCallback() {
//     super.connectedCallback();

//     const { signal } = this.#abortController;
//     const target = this.closest('.shopify-section, dialog, product-card');
//     target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
//     target?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected, { signal });

//     // Listen for cart updates to sync data-cart-quantity
//     document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate, { signal });

//     initializeCustomCartUiOnce();
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     this.#abortController.abort();
//   }

//   /**
//    * Fetches cart and updates quantity selector for current variant
//    * @returns {Promise<number>} The cart quantity for the current variant
//    */
//   async #fetchAndUpdateCartQuantity() {
//     const variantIdInput = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="id"]'));
//     if (!variantIdInput?.value) return 0;

//     try {
//       const response = await fetch('/cart.js');
//       const cart = await response.json();

//       const cartItem = cart.items.find(
//         /** @param {any} item */
//         (item) => item.variant_id.toString() === variantIdInput.value.toString()
//       );
//       const cartQty = cartItem ? cartItem.quantity : 0;

//       // Use public API to update quantity selector
//       const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//       if (quantitySelector?.setCartQuantity) {
//         quantitySelector.setCartQuantity(cartQty);
//       }

//       // Update quantity label if it exists
//       this.#updateQuantityLabel(cartQty);

//       return cartQty;
//     } catch (error) {
//       console.error('Failed to fetch cart quantity:', error);
//       return 0;
//     }
//   }

//   /**
//    * Updates data-cart-quantity when cart is updated from elsewhere
//    * @param {CartUpdateEvent|CartAddEvent} event
//    */
//   #onCartUpdate = async (event) => {
//     // Skip if this event came from this component
//     if (event.detail?.sourceId === this.id || event.detail?.data?.source === 'product-form-component') return;

//     await this.#fetchAndUpdateCartQuantity();
//   };

//   /**
//    * Handles the submit event for the product form.
//    *
//    * @param {Event} event - The submit event.
//    */
//   handleSubmit(event) {
//     const { addToCartTextError, addToCartButtonContainer } = this.refs;
//     // Stop default behaviour from the browser
//     event.preventDefault();

//     if (this.#timeout) clearTimeout(this.#timeout);

//     // Check if the add to cart button is disabled and do an early return if it is
//     if (addToCartButtonContainer?.refs.addToCartButton?.disabled) return;

//     // Send the add to cart information to the cart
//     const form = this.querySelector('form');

//     if (!form) throw new Error('Product form element missing');

//     const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//     if (quantitySelector?.canAddToCart) {
//       const validation = quantitySelector.canAddToCart();

//       if (!validation.canAdd) {
//         addToCartButtonContainer?.disable();

//         const errorTemplate = this.dataset.quantityErrorMax || '';
//         const errorMessage = errorTemplate.replace('{{ maximum }}', validation.maxQuantity.toString());
//         if (addToCartTextError) {
//           addToCartTextError.classList.remove('hidden');

//           const textNode = addToCartTextError.childNodes[2];
//           if (textNode) {
//             textNode.textContent = errorMessage;
//           } else {
//             const newTextNode = document.createTextNode(errorMessage);
//             addToCartTextError.appendChild(newTextNode);
//           }

//           this.#setLiveRegionText(errorMessage);

//           if (this.#timeout) clearTimeout(this.#timeout);
//           this.#timeout = setTimeout(() => {
//             if (!addToCartTextError) return;
//             addToCartTextError.classList.add('hidden');
//             this.#clearLiveRegionText();
//           }, ERROR_MESSAGE_DISPLAY_DURATION);
//         }

//         setTimeout(() => {
//           addToCartButtonContainer?.enable();
//         }, ERROR_BUTTON_REENABLE_DELAY);

//         return;
//       }
//     }

//     const formData = new FormData(form);
//     const quantityRaw = formData.get('quantity');
//     const quantityToAdd = Number(quantityRaw) || Number(this.dataset.quantityDefault) || 1;

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     let cartItemComponentsSectionIds = [];
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         cartItemComponentsSectionIds.push(item.dataset.sectionId);
//       }
//       formData.append('sections', cartItemComponentsSectionIds.join(','));
//     });

//     const fetchCfg = fetchConfig('javascript', { body: formData });

//     fetch(Theme.routes.cart_add_url, {
//       ...fetchCfg,
//       headers: {
//         ...fetchCfg.headers,
//         Accept: 'text/html',
//       },
//     })
//       .then((response) => response.json())
//       .then((response) => {
//         if (response.status) {
//           this.dispatchEvent(
//             new CartErrorEvent(form.getAttribute('id') || '', response.message, response.description, response.errors)
//           );

//           if (!addToCartTextError) return;
//           addToCartTextError.classList.remove('hidden');

//           // Reuse the text node if the user is spam-clicking
//           const textNode = addToCartTextError.childNodes[2];
//           if (textNode) {
//             textNode.textContent = response.message;
//           } else {
//             const newTextNode = document.createTextNode(response.message);
//             addToCartTextError.appendChild(newTextNode);
//           }

//           // Create or get existing error live region for screen readers
//           this.#setLiveRegionText(response.message);

//           this.#timeout = setTimeout(() => {
//             if (!addToCartTextError) return;
//             addToCartTextError.classList.add('hidden');

//             // Clear the announcement
//             this.#clearLiveRegionText();
//           }, ERROR_MESSAGE_DISPLAY_DURATION);

//           // When we add more than the maximum amount of items to the cart, we need to dispatch a cart update event
//           // because our back-end still adds the max allowed amount to the cart.
//           this.dispatchEvent(
//             new CartAddEvent({}, this.id, {
//               didError: true,
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//             })
//           );

//           return;
//         } else {
//           const id = formData.get('id');

//           if (addToCartTextError) {
//             addToCartTextError.classList.add('hidden');
//             addToCartTextError.removeAttribute('aria-live');
//           }

//           if (!id) throw new Error('Form ID is required');

//           // Add aria-live region to inform screen readers that the item was added
//           if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
//             const addToCartButton = this.refs.addToCartButtonContainer.refs.addToCartButton;
//             const addedTextElement = addToCartButton.querySelector('.add-to-cart-text--added');
//             const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;

//             this.#setLiveRegionText(addedText);

//             setTimeout(() => {
//               this.#clearLiveRegionText();
//             }, SUCCESS_MESSAGE_DISPLAY_DURATION);
//           }

//           // 这里是关键：加购成功后再执行数字增加与飞入动画
//           handleCustomAddSuccess(
//             quantityToAdd,
//             customLastAddToCartSourceElement,
//             id ? id.toString() : ''
//           );

//           // Fetch the updated cart to get the actual total quantity for this variant
//           this.#fetchAndUpdateCartQuantity();

//           this.dispatchEvent(
//             new CartAddEvent({}, id.toString(), {
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//               sections: response.sections,
//             })
//           );
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         cartPerformance.measureFromEvent('add:user-action', event);
//       });
//   }

//   /**
//    * Updates the quantity label with the current cart quantity
//    * @param {number} cartQty - The quantity in cart
//    */
//   #updateQuantityLabel(cartQty) {
//     const quantityLabel = this.refs.quantityLabelCartCount;
//     if (quantityLabel) {
//       const inCartText = quantityLabel.textContent?.match(/\((\d+)\s+(.+)\)/);
//       if (inCartText && inCartText[2]) {
//         quantityLabel.textContent = `(${cartQty} ${inCartText[2]})`;
//       }

//       // Show/hide based on quantity
//       quantityLabel.classList.toggle('hidden', cartQty === 0);
//     }
//   }

//   /**
//    * @param {*} text
//    */
//   #setLiveRegionText(text) {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = text;
//   }

//   #clearLiveRegionText() {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = '';
//   }

//   /**
//    * Morphs or removes/adds an element based on current and new element states
//    * @param {Element | null | undefined} currentElement - The current element in the DOM
//    * @param {Element | null | undefined} newElement - The new element from the server response
//    * @param {Element | null} [insertReferenceElement] - Element to insert before if adding new element
//    */
//   #morphOrUpdateElement(currentElement, newElement, insertReferenceElement = null) {
//     if (currentElement && newElement) {
//       morph(currentElement, newElement);
//     } else if (currentElement && !newElement) {
//       currentElement.remove();
//     } else if (!currentElement && newElement && insertReferenceElement) {
//       insertReferenceElement.insertAdjacentElement('beforebegin', /** @type {Element} */ (newElement.cloneNode(true)));
//     }
//   }

//   /**
//    * @param {VariantUpdateEvent} event
//    */
//   #onVariantUpdate = async (event) => {
//     if (event.detail.data.newProduct) {
//       this.dataset.productId = event.detail.data.newProduct.id;
//     } else if (event.detail.data.productId !== this.dataset.productId) {
//       return;
//     }

//     const { variantId, addToCartButtonContainer } = this.refs;

//     const currentAddToCartButton = addToCartButtonContainer?.refs.addToCartButton;
//     const newAddToCartButton = event.detail.data.html.querySelector('[ref="addToCartButton"]');

//     // Update the variant ID
//     variantId.value = event.detail.resource?.id ?? '';

//     if (!currentAddToCartButton && !this.refs.acceleratedCheckoutButtonContainer) return;

//     // Update the button state
//     if (currentAddToCartButton) {
//       if (event.detail.resource == null || event.detail.resource.available == false) {
//         addToCartButtonContainer.disable();
//       } else {
//         addToCartButtonContainer.enable();
//       }

//       // Update the add to cart button text and icon
//       if (newAddToCartButton) {
//         morph(currentAddToCartButton, newAddToCartButton);
//       }
//     }

//     if (this.refs.acceleratedCheckoutButtonContainer) {
//       if (event.detail.resource == null || event.detail.resource.available == false) {
//         this.refs.acceleratedCheckoutButtonContainer?.setAttribute('hidden', 'true');
//       } else {
//         this.refs.acceleratedCheckoutButtonContainer?.removeAttribute('hidden');
//       }
//     }

//     // Set the data attribute for the add to cart button to the product variant media if it exists
//     if (event.detail.resource) {
//       const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
//       productVariantMedia &&
//         addToCartButtonContainer?.setAttribute('data-product-variant-media', productVariantMedia + '&width=100');
//     }

//     // Update quantity selector's min/max/step attributes and cart quantity for the new variant
//     const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//     const newQuantityInput = /** @type {HTMLInputElement | null} */ (
//       event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
//     );

//     if (quantitySelector?.updateConstraints && newQuantityInput) {
//       quantitySelector.updateConstraints(
//         newQuantityInput.min,
//         newQuantityInput.max || null,
//         newQuantityInput.step
//       );
//     }

//     // Check if quantity rules are appearing/disappearing (causes layout shift)
//     const quantityRules = this.refs.quantityRules;
//     const newQuantityRules = event.detail.data.html.querySelector('.quantity-rules');
//     const isQuantityRulesChanging = !!quantityRules !== !!newQuantityRules;

//     if (isQuantityRulesChanging && quantitySelector) {
//       // Store quantity value before morphing entire container
//       const currentQuantityValue = quantitySelector.getValue?.();

//       const currentProductFormButtons = this.refs.productFormButtons;
//       const newProductFormButtons = event.detail.data.html.querySelector('.product-form-buttons');

//       if (currentProductFormButtons && newProductFormButtons) {
//         morph(currentProductFormButtons, newProductFormButtons);

//         // Get the NEW quantity selector after morphing and update its constraints
//         const newQuantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//         const newQuantityInputElement = /** @type {HTMLInputElement | null} */ (
//           event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
//         );

//         if (newQuantitySelector?.updateConstraints && newQuantityInputElement && currentQuantityValue) {
//           // Temporarily set the old value so updateConstraints can snap it properly
//           newQuantitySelector.setValue(currentQuantityValue);
//           // updateConstraints will snap to valid increment if needed
//           newQuantitySelector.updateConstraints(
//             newQuantityInputElement.min,
//             newQuantityInputElement.max || null,
//             newQuantityInputElement.step
//           );
//         }
//       }
//     } else {
//       // Update elements individually when layout isn't changing
//       const quantityLabel = this.querySelector('.quantity-label');
//       const newQuantityLabel = event.detail.data.html.querySelector('.quantity-label');
//       this.#morphOrUpdateElement(quantityLabel, newQuantityLabel, quantitySelector);

//       const addToCartButton = this.querySelector('[ref="addToCartButtonContainer"]');
//       this.#morphOrUpdateElement(quantityRules, newQuantityRules, addToCartButton);
//     }

//     // Fetch and update cart quantity for the new variant
//     await this.#fetchAndUpdateCartQuantity();
//   };

//   /**
//    * Disable the add to cart button while the UI is updating before #onVariantUpdate is called.
//    * Accelerated checkout button is also disabled via its own event listener not exposed to the theme.
//    */
//   #onVariantSelected = () => {
//     this.refs.addToCartButtonContainer?.disable();
//   };
// }

// if (!customElements.get('product-form-component')) {
//   customElements.define('product-form-component', ProductFormComponent);
// }

// class FlyToCart extends HTMLElement {
//   /** @type {Element | null} */
//   source = null;

//   /** @type {{left:number, top:number, width:number, height:number} | null} */
//   sourceRect = null;

//   /** @type {Element | null} */
//   destination = null;

//   connectedCallback() {
//     customCartAnimationLock = true;

//     if (customCartAnimationUnlockTimer) {
//       clearTimeout(customCartAnimationUnlockTimer);
//     }

//     // 兜底：无论如何，1.2 秒后强制解锁
//     customCartAnimationUnlockTimer = window.setTimeout(() => {
//       customCartAnimationLock = false;
//       customCartAnimationUnlockTimer = null;
//       if (this.isConnected) this.remove();
//     }, 1200);

//     this.#animate();
//   }

//   #animate() {
//     if (!this.destination) {
//       customCartAnimationLock = false;
//       if (customCartAnimationUnlockTimer) {
//         clearTimeout(customCartAnimationUnlockTimer);
//         customCartAnimationUnlockTimer = null;
//       }
//       this.remove();
//       return;
//     }

//     const rect = this.getBoundingClientRect();
//     const destinationRect = this.destination.getBoundingClientRect();

//     let sourceRect;

//     if (this.sourceRect) {
//       sourceRect = this.sourceRect;
//     } else if (this.source instanceof Element) {
//       const liveRect = this.source.getBoundingClientRect();
//       sourceRect = {
//         left: liveRect.left,
//         top: liveRect.top,
//         width: liveRect.width,
//         height: liveRect.height,
//       };
//     } else {
//       customCartAnimationLock = false;
//       if (customCartAnimationUnlockTimer) {
//         clearTimeout(customCartAnimationUnlockTimer);
//         customCartAnimationUnlockTimer = null;
//       }
//       this.remove();
//       return;
//     }

//     const offset = {
//       x: rect.width / 2,
//       y: rect.height / 2,
//     };

//     const startPoint = {
//       x: sourceRect.left + sourceRect.width / 2 - offset.x,
//       y: sourceRect.top + sourceRect.height / 2 - offset.y,
//     };

//     const endPoint = {
//       x: destinationRect.left + destinationRect.width / 2 - offset.x,
//       y: destinationRect.top + destinationRect.height / 2 - offset.y,
//     };

//     const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 };
//     const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 };

//     let startTime = null;
//     const duration = 600;

//     this.style.opacity = '1';
//     this.style.setProperty('--x', `${startPoint.x}px`);
//     this.style.setProperty('--y', `${startPoint.y}px`);

//     const animate = (currentTime) => {
//       if (!startTime) startTime = currentTime;
//       const elapsed = currentTime - startTime;
//       const progress = Math.min(elapsed / duration, 1);

//       const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

//       this.style.setProperty('--x', `${position.x}px`);
//       this.style.setProperty('--y', `${position.y}px`);

//       const scale = 1 - progress * 0.5;
//       this.style.setProperty('--scale', `${scale}`);

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         this.style.opacity = '0';

//         // 不再依赖 onAnimationEnd，直接稳定收尾
//         setTimeout(() => {
//           customCartAnimationLock = false;
//           if (customCartAnimationUnlockTimer) {
//             clearTimeout(customCartAnimationUnlockTimer);
//             customCartAnimationUnlockTimer = null;
//           }
//           if (this.isConnected) this.remove();
//         }, 120);
//       }
//     };

//     requestAnimationFrame(animate);
//   }
// }

// /**
//  * Calculates a point on a cubic Bézier curve.
//  * @param {number} t - The parameter value (0 <= t <= 1).
//  * @param {{x: number, y: number}} p0 - The starting point (x, y).
//  * @param {{x: number, y: number}} p1 - The first control point (x, y).
//  * @param {{x: number, y: number}} p2 - The second control point (x, y).
//  * @param {{x: number, y: number}} p3 - The ending point (x, y).
//  * @returns {{x: number, y: number}} The point on the curve.
//  */
// function bezierPoint(t, p0, p1, p2, p3) {
//   const cX = 3 * (p1.x - p0.x);
//   const bX = 3 * (p2.x - p1.x) - cX;
//   const aX = p3.x - p0.x - cX - bX;

//   const cY = 3 * (p1.y - p0.y);
//   const bY = 3 * (p2.y - p1.y) - cY;
//   const aY = p3.y - p0.y - cY - bY;

//   const x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x;
//   const y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y;

//   return { x, y };
// }

// if (!customElements.get('fly-to-cart')) {
//   customElements.define('fly-to-cart', FlyToCart);
// }


// ################################以下是飞入2.0########################################################################

// import { Component } from '@theme/component';
// import { fetchConfig, onAnimationEnd, preloadImage } from '@theme/utilities';
// import { ThemeEvents, CartAddEvent, CartErrorEvent, CartUpdateEvent, VariantUpdateEvent } from '@theme/events';
// import { cartPerformance } from '@theme/performance';
// import { morph } from '@theme/morph';

// export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;

// // Error message display duration - gives users time to read the message
// const ERROR_MESSAGE_DISPLAY_DURATION = 10000;

// // Button re-enable delay after error - prevents rapid repeat attempts
// const ERROR_BUTTON_REENABLE_DELAY = 1000;

// // Success message display duration for screen readers
// const SUCCESS_MESSAGE_DISPLAY_DURATION = 5000;

// // =========================
// // 自定义：购物车徽标与飞入动画配置
// // =========================
// const CUSTOM_CART_COUNT_STORAGE_KEY = 'custom_cart_click_count_v2';
// const CUSTOM_CART_ICON_SELECTORS = [
//   '.header-actions__cart-icon',
//   '#cart-icon-bubble',
//   '.header__icon--cart',
//   'cart-drawer-opener',
//   'a[href="/cart"]',
//   'a[href*="/cart"]',
//   '[data-cart-icon]',
//   '.site-header__cart',
//   '.header__cart',
//   '.header a[href="/cart"]',
//   '.header a[href*="/cart"]',
// ];

// let customLastAddToCartSourceElement = null;
// let customLastAddToCartSourceRect = null;
// let customCartAnimationLock = false;
// let customCartAnimationUnlockTimer = null;
// let customCartUiInitialized = false;

// // 防止一次加购成功被重复处理
// let customLastSuccessSignature = '';
// let customLastSuccessAt = 0;

// /**
//  * 获取 localStorage 数量
//  * @returns {number}
//  */
// function getCustomStoredCartCount() {
//   try {
//     const raw = localStorage.getItem(CUSTOM_CART_COUNT_STORAGE_KEY);
//     const num = parseInt(raw || '0', 10);
//     return Number.isNaN(num) ? 0 : Math.max(0, num);
//   } catch (e) {
//     return 0;
//   }
// }

// /**
//  * 设置 localStorage 数量
//  * @param {number} value
//  */
// function setCustomStoredCartCount(value) {
//   try {
//     localStorage.setItem(CUSTOM_CART_COUNT_STORAGE_KEY, String(Math.max(0, value)));
//   } catch (e) {}
// }

// /**
//  * 增加 localStorage 数量
//  * @param {number} step
//  * @returns {number}
//  */
// function incrementCustomStoredCartCount(step = 1) {
//   const current = getCustomStoredCartCount();
//   const next = current + Math.max(1, step);
//   setCustomStoredCartCount(next);
//   return next;
// }

// /**
//  * 清空 localStorage 数量
//  */
// function clearCustomStoredCartCount() {
//   try {
//     localStorage.removeItem(CUSTOM_CART_COUNT_STORAGE_KEY);
//   } catch (e) {}
// }

// /**
//  * 是否购物车页
//  * @returns {boolean}
//  */
// function isCustomCartPage() {
//   return window.location.pathname === '/cart';
// }

// /**
//  * 获取所有购物车 icon
//  * @returns {Element[]}
//  */
// function getAllCustomCartIcons() {
//   const found = [];
//   const seen = new Set();

//   CUSTOM_CART_ICON_SELECTORS.forEach((selector) => {
//     document.querySelectorAll(selector).forEach((el) => {
//       if (!seen.has(el)) {
//         seen.add(el);
//         found.push(el);
//       }
//     });
//   });

//   return found;
// }

// /**
//  * 获取当前可见购物车 icon
//  * @returns {Element | null}
//  */
// function getVisibleCustomCartIcon() {
//   const icons = getAllCustomCartIcons();
//   const visible = icons.find((el) => {
//     const rect = el.getBoundingClientRect();
//     return rect.width > 0 && rect.height > 0;
//   });
//   return visible || icons[0] || null;
// }

// /**
//  * 获取或创建购物车徽标
//  * @param {Element} cartIcon
//  * @returns {HTMLElement | null}
//  */
// function getOrCreateCustomCartBadge(cartIcon) {
//   if (!(cartIcon instanceof HTMLElement)) return null;

//   cartIcon.classList.add('cart-icon-badge-anchor');

//   let badge = cartIcon.querySelector('.cart-count-badge--custom');
//   if (!badge) {
//     badge = document.createElement('span');
//     badge.className = 'cart-count-badge--custom is-hidden';
//     badge.setAttribute('aria-hidden', 'true');
//     badge.textContent = '0';
//     cartIcon.appendChild(badge);
//   }

//   return /** @type {HTMLElement} */ (badge);
// }

// /**
//  * 更新所有购物车徽标
//  * @param {number} count
//  */
// function updateAllCustomCartBadges(count) {
//   const icons = getAllCustomCartIcons();
//   icons.forEach((icon) => {
//     const badge = getOrCreateCustomCartBadge(icon);
//     if (!badge) return;

//     badge.textContent = count > 99 ? '99+' : String(count);

//     if (count > 0) {
//       badge.classList.remove('is-hidden');
//     } else {
//       badge.classList.add('is-hidden');
//     }
//   });
// }

// /**
//  * 从 localStorage 同步徽标
//  */
// function syncCustomCartBadgesFromStorage() {
//   updateAllCustomCartBadges(getCustomStoredCartCount());
// }

// /**
//  * 从真实 cart 同步徽标
//  */
// async function syncCustomCartBadgesFromCart() {
//   try {
//     const response = await fetch('/cart.js', {
//       headers: {
//         Accept: 'application/json',
//       },
//       credentials: 'same-origin',
//     });

//     if (!response.ok) {
//       throw new Error('Failed to fetch cart');
//     }

//     const cart = await response.json();
//     const actualCount = Number(cart.item_count) || 0;

//     setCustomStoredCartCount(actualCount);
//     updateAllCustomCartBadges(actualCount);

//     return actualCount;
//   } catch (error) {
//     syncCustomCartBadgesFromStorage();
//     return getCustomStoredCartCount();
//   }
// }

// /**
//  * 清空徽标显示
//  */
// function clearCustomCartBadgesImmediately() {
//   updateAllCustomCartBadges(0);
// }

// /**
//  * 购物车图标抖动
//  * @param {Element | null} cartIcon
//  */
// function bounceCustomCartIcon(cartIcon) {
//   if (!(cartIcon instanceof HTMLElement)) return;

//   cartIcon.classList.remove('cart-icon-bounce');
//   void cartIcon.offsetWidth;
//   cartIcon.classList.add('cart-icon-bounce');

//   setTimeout(() => {
//     cartIcon.classList.remove('cart-icon-bounce');
//   }, 700);
// }

// /**
//  * 确保样式只注入一次
//  */
// function ensureCustomCartUiStyles() {
//   if (document.getElementById('custom-cart-badge-styles')) return;

//   const style = document.createElement('style');
//   style.id = 'custom-cart-badge-styles';
//   style.textContent = `
//     .cart-icon-badge-anchor {
//       position: relative !important;
//       overflow: visible !important;
//     }

//     .cart-count-badge--custom {
//       position: absolute;
//       top: -8px;
//       right: -12px;
//       min-width: 22px;
//       height: 22px;
//       padding: 0 6px;
//       border-radius: 999px;
//       background: #e3a23a;
//       color: #fff;
//       font-size: 12px;
//       line-height: 22px;
//       font-weight: 700;
//       text-align: center;
//       white-space: nowrap;
//       box-shadow: 0 4px 10px rgba(227, 162, 58, 0.28);
//       border: 2px solid #fff;
//       z-index: 999;
//       pointer-events: none;
//     }

//     .cart-count-badge--custom.is-hidden {
//       display: none;
//     }

//     .cart-icon-bounce {
//       animation: cartIconBounce 0.62s ease;
//     }

//     @keyframes cartIconBounce {
//       0% { transform: scale(1); }
//       25% { transform: scale(1.16); }
//       50% { transform: scale(0.94); }
//       75% { transform: scale(1.08); }
//       100% { transform: scale(1); }
//     }

//     fly-to-cart,
//     fly-to-cart * {
//       pointer-events: none !important;
//     }

//     fly-to-cart {
//       position: fixed !important;
//       z-index: 2147483647 !important;
//     }

//     @media (max-width: 749px) {
//       .cart-count-badge--custom {
//         top: -6px;
//         right: -10px;
//       }
//     }
//   `;
//   document.head.appendChild(style);
// }

// /**
//  * 初始化购物车 UI 事件
//  */
// function initializeCustomCartUiOnce() {
//   if (customCartUiInitialized) return;
//   customCartUiInitialized = true;

//   ensureCustomCartUiStyles();

//   syncCustomCartBadgesFromStorage();
//   setTimeout(syncCustomCartBadgesFromStorage, 60);

//   syncCustomCartBadgesFromCart();
//   setTimeout(syncCustomCartBadgesFromCart, 300);
//   setTimeout(syncCustomCartBadgesFromCart, 1200);

//   document.addEventListener(
//     'click',
//     (event) => {
//       const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
//       if (!target) return;

//       const cartHit = target.closest(CUSTOM_CART_ICON_SELECTORS.join(', '));

//       if (cartHit) {
//         setTimeout(() => {
//           syncCustomCartBadgesFromCart();
//         }, 50);
//       }
//     },
//     true
//   );

//   window.addEventListener('storage', (event) => {
//     if (event.key === CUSTOM_CART_COUNT_STORAGE_KEY) {
//       if (isCustomCartPage()) {
//         clearCustomStoredCartCount();
//         clearCustomCartBadgesImmediately();
//       } else {
//         syncCustomCartBadgesFromStorage();
//       }
//     }
//   });

//   document.addEventListener('shopify:section:load', () => {
//     setTimeout(syncCustomCartBadgesFromCart, 100);
//   });

//   document.addEventListener('shopify:section:reorder', () => {
//     setTimeout(syncCustomCartBadgesFromCart, 100);
//   });

//   document.addEventListener('shopify:block:select', () => {
//     setTimeout(syncCustomCartBadgesFromCart, 100);
//   });
// }

// /**
//  * 从 source 飞向 cart
//  * @param {Element | null | undefined} source
//  * @param {Element | null | undefined} destination
//  */
// function runCustomFlyToCart(source, destination) {
//   const cartIcon = destination || getVisibleCustomCartIcon();

//   if (!cartIcon) {
//     return;
//   }

//   if (customCartAnimationLock) {
//     bounceCustomCartIcon(cartIcon);
//     return;
//   }

//   const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

//   if (source instanceof Element) {
//     flyToCartElement.source = source;
//   }

//   if (customLastAddToCartSourceRect) {
//     flyToCartElement.sourceRect = customLastAddToCartSourceRect;
//   }

//   flyToCartElement.destination = cartIcon;
//   document.body.appendChild(flyToCartElement);
// }

// /**
//  * 加购成功后的统一处理
//  * @param {number} quantityToAdd
//  * @param {Element | null | undefined} sourceElement
//  * @param {string} variantId
//  */
// function handleCustomAddSuccess(quantityToAdd, sourceElement, variantId = '') {
//   initializeCustomCartUiOnce();

//   const now = Date.now();
//   const rect = customLastAddToCartSourceRect;
//   const rectKey = rect
//     ? `${Math.round(rect.left)}-${Math.round(rect.top)}-${Math.round(rect.width)}-${Math.round(rect.height)}`
//     : 'no-rect';

//   const successSignature = `${variantId || 'no-variant'}|${quantityToAdd}|${rectKey}`;

//   if (customLastSuccessSignature === successSignature && now - customLastSuccessAt < 450) {
//     return;
//   }

//   customLastSuccessSignature = successSignature;
//   customLastSuccessAt = now;

//   const nextCount = incrementCustomStoredCartCount(quantityToAdd);
//   updateAllCustomCartBadges(nextCount);

//   const cartIcon = getVisibleCustomCartIcon();
//   runCustomFlyToCart(sourceElement || customLastAddToCartSourceElement, cartIcon);

//   setTimeout(syncCustomCartBadgesFromCart, 120);
//   setTimeout(syncCustomCartBadgesFromCart, 400);
//   setTimeout(syncCustomCartBadgesFromCart, 900);
//   setTimeout(syncCustomCartBadgesFromCart, 1500);
// }

// function rememberCustomAddSource(sourceElement) {
//   if (!(sourceElement instanceof Element)) return;

//   customLastAddToCartSourceElement = sourceElement;

//   const rect = sourceElement.getBoundingClientRect();
//   customLastAddToCartSourceRect = {
//     left: rect.left,
//     top: rect.top,
//     width: rect.width,
//     height: rect.height,
//   };
// }

// async function addCustomUpsellItem({
//   variantId,
//   quantity = 1,
//   sourceElement = null,
//   sections = '',
// }) {
//   if (!variantId) {
//     throw new Error('Upsell add to cart requires a variantId');
//   }

//   initializeCustomCartUiOnce();

//   if (sourceElement instanceof Element) {
//     rememberCustomAddSource(sourceElement);
//   }

//   const formData = new FormData();
//   formData.append('id', String(variantId));
//   formData.append('quantity', String(Math.max(1, Number(quantity) || 1)));

//   if (sections) {
//     formData.append('sections', sections);
//   }

//   const response = await fetch(Theme.routes.cart_add_url || '/cart/add.js', {
//     method: 'POST',
//     headers: {
//       Accept: 'application/json',
//     },
//     body: formData,
//   });

//   const data = await response.json();

//   if (!response.ok || data.status) {
//     throw new Error(data.description || data.message || 'Failed to add upsell item to cart');
//   }

//   handleCustomAddSuccess(
//     Math.max(1, Number(quantity) || 1),
//     sourceElement || customLastAddToCartSourceElement,
//     String(variantId)
//   );

//   return data;
// }

// window.CustomUpsellCart = window.CustomUpsellCart || {
//   rememberSource: rememberCustomAddSource,
//   handleSuccess: handleCustomAddSuccess,
//   addItem: addCustomUpsellItem,
//   init: initializeCustomCartUiOnce,
//   syncBadge: syncCustomCartBadgesFromCart,
// };

// /**
//  * A custom element that manages an add to cart button.
//  *
//  * @typedef {object} AddToCartRefs
//  * @property {HTMLButtonElement} addToCartButton - The add to cart button.
//  * @extends Component<AddToCartRefs>
//  */
// export class AddToCartComponent extends Component {
//   requiredRefs = ['addToCartButton'];

//   /** @type {number | undefined} */
//   #animationTimeout;

//   /** @type {number | undefined} */
//   #cleanupTimeout;

//   connectedCallback() {
//     super.connectedCallback();

//     this.addEventListener('pointerenter', this.#preloadImage);
//     this.addEventListener('pointerdown', this.#rememberSource, true);

//     initializeCustomCartUiOnce();
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);
//     this.removeEventListener('pointerenter', this.#preloadImage);
//     this.removeEventListener('pointerdown', this.#rememberSource, true);
//   }

//   disable() {
//     this.refs.addToCartButton.disabled = true;
//   }

//   enable() {
//     this.refs.addToCartButton.disabled = false;
//   }

//   /**
//    * 记录最近一次点击源按钮
//    * @param {PointerEvent} event
//    */
//   #rememberSource = (event) => {
//     const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
//     if (!target) return;

//     const button =
//       target.closest('button') ||
//       this.refs.addToCartButton ||
//       this;

//     customLastAddToCartSourceElement = button;

//     if (button instanceof Element) {
//       const rect = button.getBoundingClientRect();
//       customLastAddToCartSourceRect = {
//         left: rect.left,
//         top: rect.top,
//         width: rect.width,
//         height: rect.height,
//       };
//     }
//   };

//   /**
//    * Handles the click event for the add to cart button.
//    * @param {MouseEvent & {target: HTMLElement}} event
//    */
//   handleClick(event) {
//     const form = this.closest('form');
//     if (!form?.checkValidity()) return;

//     const quantitySelector = /** @type {any} */ (form.querySelector('quantity-selector-component'));
//     if (quantitySelector?.canAddToCart) {
//       const validation = quantitySelector.canAddToCart();
//       if (!validation.canAdd) {
//         return;
//       }
//     }

//     this.animateAddToCart();

//     customLastAddToCartSourceElement =
//       event.target.closest('button') ||
//       this.refs.addToCartButton ||
//       this;

//     if (customLastAddToCartSourceElement instanceof Element) {
//       const rect = customLastAddToCartSourceElement.getBoundingClientRect();
//       customLastAddToCartSourceRect = {
//         left: rect.left,
//         top: rect.top,
//         width: rect.width,
//         height: rect.height,
//       };
//     }
//   }

//   #preloadImage = () => {
//     const image = this.dataset.productVariantMedia;

//     if (!image) return;

//     preloadImage(image);
//   };

//   animateAddToCart() {
//     const { addToCartButton } = this.refs;

//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);

//     if (!addToCartButton.classList.contains('atc-added')) {
//       addToCartButton.classList.add('atc-added');
//     }

//     this.#animationTimeout = setTimeout(() => {
//       this.#cleanupTimeout = setTimeout(() => {
//         this.refs.addToCartButton.classList.remove('atc-added');
//       }, 10);
//     }, ADD_TO_CART_TEXT_ANIMATION_DURATION);
//   }
// }

// if (!customElements.get('add-to-cart-component')) {
//   customElements.define('add-to-cart-component', AddToCartComponent);
// }

// /**
//  * A custom element that manages a product form.
//  *
//  * @typedef {object} ProductFormRefs
//  * @property {HTMLInputElement} variantId
//  * @property {AddToCartComponent | undefined} addToCartButtonContainer
//  * @property {HTMLElement | undefined} addToCartTextError
//  * @property {HTMLElement | undefined} acceleratedCheckoutButtonContainer
//  * @property {HTMLElement} liveRegion
//  * @property {HTMLElement | undefined} quantityLabelCartCount
//  * @property {HTMLElement | undefined} quantityRules
//  * @property {HTMLElement | undefined} productFormButtons
//  *
//  * @extends Component<ProductFormRefs>
//  */
// class ProductFormComponent extends Component {
//   requiredRefs = ['variantId', 'liveRegion'];
//   #abortController = new AbortController();

//   /** @type {number | undefined} */
//   #timeout;

//   connectedCallback() {
//     super.connectedCallback();

//     const { signal } = this.#abortController;
//     const target = this.closest('.shopify-section, dialog, product-card');
//     target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
//     target?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected, { signal });

//     document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate, { signal });

//     initializeCustomCartUiOnce();
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     this.#abortController.abort();
//   }

//   async #fetchAndUpdateCartQuantity() {
//     const variantIdInput = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="id"]'));
//     if (!variantIdInput?.value) return 0;

//     try {
//       const response = await fetch('/cart.js');
//       const cart = await response.json();

//       const cartItem = cart.items.find(
//         /** @param {any} item */
//         (item) => item.variant_id.toString() === variantIdInput.value.toString()
//       );
//       const cartQty = cartItem ? cartItem.quantity : 0;

//       const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//       if (quantitySelector?.setCartQuantity) {
//         quantitySelector.setCartQuantity(cartQty);
//       }

//       this.#updateQuantityLabel(cartQty);

//       return cartQty;
//     } catch (error) {
//       console.error('Failed to fetch cart quantity:', error);
//       return 0;
//     }
//   }

//   /**
//    * @param {CartUpdateEvent|CartAddEvent} event
//    */
//   #onCartUpdate = async (event) => {
//     if (event.detail?.sourceId === this.id || event.detail?.data?.source === 'product-form-component') return;
//     await this.#fetchAndUpdateCartQuantity();
//   };

//   handleSubmit(event) {
//     const { addToCartTextError, addToCartButtonContainer } = this.refs;
//     event.preventDefault();

//     if (this.#timeout) clearTimeout(this.#timeout);
//     if (addToCartButtonContainer?.refs.addToCartButton?.disabled) return;

//     const form = this.querySelector('form');
//     if (!form) throw new Error('Product form element missing');

//     const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//     if (quantitySelector?.canAddToCart) {
//       const validation = quantitySelector.canAddToCart();

//       if (!validation.canAdd) {
//         addToCartButtonContainer?.disable();

//         const errorTemplate = this.dataset.quantityErrorMax || '';
//         const errorMessage = errorTemplate.replace('{{ maximum }}', validation.maxQuantity.toString());
//         if (addToCartTextError) {
//           addToCartTextError.classList.remove('hidden');

//           const textNode = addToCartTextError.childNodes[2];
//           if (textNode) {
//             textNode.textContent = errorMessage;
//           } else {
//             const newTextNode = document.createTextNode(errorMessage);
//             addToCartTextError.appendChild(newTextNode);
//           }

//           this.#setLiveRegionText(errorMessage);

//           if (this.#timeout) clearTimeout(this.#timeout);
//           this.#timeout = setTimeout(() => {
//             if (!addToCartTextError) return;
//             addToCartTextError.classList.add('hidden');
//             this.#clearLiveRegionText();
//           }, ERROR_MESSAGE_DISPLAY_DURATION);
//         }

//         setTimeout(() => {
//           addToCartButtonContainer?.enable();
//         }, ERROR_BUTTON_REENABLE_DELAY);

//         return;
//       }
//     }

//     const formData = new FormData(form);
//     const quantityRaw = formData.get('quantity');
//     const quantityToAdd = Number(quantityRaw) || Number(this.dataset.quantityDefault) || 1;

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     let cartItemComponentsSectionIds = [];
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         cartItemComponentsSectionIds.push(item.dataset.sectionId);
//       }
//       formData.append('sections', cartItemComponentsSectionIds.join(','));
//     });

//     const fetchCfg = fetchConfig('javascript', { body: formData });

//     fetch(Theme.routes.cart_add_url, {
//       ...fetchCfg,
//       headers: {
//         ...fetchCfg.headers,
//         Accept: 'text/html',
//       },
//     })
//       .then((response) => response.json())
//       .then((response) => {
//         if (response.status) {
//           this.dispatchEvent(
//             new CartErrorEvent(form.getAttribute('id') || '', response.message, response.description, response.errors)
//           );

//           if (!addToCartTextError) return;
//           addToCartTextError.classList.remove('hidden');

//           const textNode = addToCartTextError.childNodes[2];
//           if (textNode) {
//             textNode.textContent = response.message;
//           } else {
//             const newTextNode = document.createTextNode(response.message);
//             addToCartTextError.appendChild(newTextNode);
//           }

//           this.#setLiveRegionText(response.message);

//           this.#timeout = setTimeout(() => {
//             if (!addToCartTextError) return;
//             addToCartTextError.classList.add('hidden');
//             this.#clearLiveRegionText();
//           }, ERROR_MESSAGE_DISPLAY_DURATION);

//           this.dispatchEvent(
//             new CartAddEvent({}, this.id, {
//               didError: true,
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//             })
//           );

//           return;
//         } else {
//           const id = formData.get('id');

//           if (addToCartTextError) {
//             addToCartTextError.classList.add('hidden');
//             addToCartTextError.removeAttribute('aria-live');
//           }

//           if (!id) throw new Error('Form ID is required');

//           if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
//             const addToCartButton = this.refs.addToCartButtonContainer.refs.addToCartButton;
//             const addedTextElement = addToCartButton.querySelector('.add-to-cart-text--added');
//             const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;

//             this.#setLiveRegionText(addedText);

//             setTimeout(() => {
//               this.#clearLiveRegionText();
//             }, SUCCESS_MESSAGE_DISPLAY_DURATION);
//           }

//           handleCustomAddSuccess(
//             quantityToAdd,
//             customLastAddToCartSourceElement,
//             id ? id.toString() : ''
//           );

//           this.#fetchAndUpdateCartQuantity();

//           this.dispatchEvent(
//             new CartAddEvent({}, id.toString(), {
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//               sections: response.sections,
//             })
//           );
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         cartPerformance.measureFromEvent('add:user-action', event);
//       });
//   }

//   #updateQuantityLabel(cartQty) {
//     const quantityLabel = this.refs.quantityLabelCartCount;
//     if (quantityLabel) {
//       const inCartText = quantityLabel.textContent?.match(/\((\d+)\s+(.+)\)/);
//       if (inCartText && inCartText[2]) {
//         quantityLabel.textContent = `(${cartQty} ${inCartText[2]})`;
//       }

//       quantityLabel.classList.toggle('hidden', cartQty === 0);
//     }
//   }

//   #setLiveRegionText(text) {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = text;
//   }

//   #clearLiveRegionText() {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = '';
//   }

//   #morphOrUpdateElement(currentElement, newElement, insertReferenceElement = null) {
//     if (currentElement && newElement) {
//       morph(currentElement, newElement);
//     } else if (currentElement && !newElement) {
//       currentElement.remove();
//     } else if (!currentElement && newElement && insertReferenceElement) {
//       insertReferenceElement.insertAdjacentElement('beforebegin', /** @type {Element} */ (newElement.cloneNode(true)));
//     }
//   }

//   #onVariantUpdate = async (event) => {
//     if (event.detail.data.newProduct) {
//       this.dataset.productId = event.detail.data.newProduct.id;
//     } else if (event.detail.data.productId !== this.dataset.productId) {
//       return;
//     }

//     const { variantId, addToCartButtonContainer } = this.refs;

//     const currentAddToCartButton = addToCartButtonContainer?.refs.addToCartButton;
//     const newAddToCartButton = event.detail.data.html.querySelector('[ref="addToCartButton"]');

//     variantId.value = event.detail.resource?.id ?? '';

//     if (!currentAddToCartButton && !this.refs.acceleratedCheckoutButtonContainer) return;

//     if (currentAddToCartButton) {
//       if (event.detail.resource == null || event.detail.resource.available == false) {
//         addToCartButtonContainer.disable();
//       } else {
//         addToCartButtonContainer.enable();
//       }

//       if (newAddToCartButton) {
//         morph(currentAddToCartButton, newAddToCartButton);
//       }
//     }

//     if (this.refs.acceleratedCheckoutButtonContainer) {
//       if (event.detail.resource == null || event.detail.resource.available == false) {
//         this.refs.acceleratedCheckoutButtonContainer?.setAttribute('hidden', 'true');
//       } else {
//         this.refs.acceleratedCheckoutButtonContainer?.removeAttribute('hidden');
//       }
//     }

//     if (event.detail.resource) {
//       const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
//       productVariantMedia &&
//         addToCartButtonContainer?.setAttribute('data-product-variant-media', productVariantMedia + '&width=100');
//     }

//     const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//     const newQuantityInput = /** @type {HTMLInputElement | null} */ (
//       event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
//     );

//     if (quantitySelector?.updateConstraints && newQuantityInput) {
//       quantitySelector.updateConstraints(
//         newQuantityInput.min,
//         newQuantityInput.max || null,
//         newQuantityInput.step
//       );
//     }

//     const quantityRules = this.refs.quantityRules;
//     const newQuantityRules = event.detail.data.html.querySelector('.quantity-rules');
//     const isQuantityRulesChanging = !!quantityRules !== !!newQuantityRules;

//     if (isQuantityRulesChanging && quantitySelector) {
//       const currentQuantityValue = quantitySelector.getValue?.();

//       const currentProductFormButtons = this.refs.productFormButtons;
//       const newProductFormButtons = event.detail.data.html.querySelector('.product-form-buttons');

//       if (currentProductFormButtons && newProductFormButtons) {
//         morph(currentProductFormButtons, newProductFormButtons);

//         const newQuantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
//         const newQuantityInputElement = /** @type {HTMLInputElement | null} */ (
//           event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
//         );

//         if (newQuantitySelector?.updateConstraints && newQuantityInputElement && currentQuantityValue) {
//           newQuantitySelector.setValue(currentQuantityValue);
//           newQuantitySelector.updateConstraints(
//             newQuantityInputElement.min,
//             newQuantityInputElement.max || null,
//             newQuantityInputElement.step
//           );
//         }
//       }
//     } else {
//       const quantityLabel = this.querySelector('.quantity-label');
//       const newQuantityLabel = event.detail.data.html.querySelector('.quantity-label');
//       this.#morphOrUpdateElement(quantityLabel, newQuantityLabel, quantitySelector);

//       const addToCartButton = this.querySelector('[ref="addToCartButtonContainer"]');
//       this.#morphOrUpdateElement(quantityRules, newQuantityRules, addToCartButton);
//     }

//     await this.#fetchAndUpdateCartQuantity();
//   };

//   #onVariantSelected = () => {
//     this.refs.addToCartButtonContainer?.disable();
//   };
// }

// if (!customElements.get('product-form-component')) {
//   customElements.define('product-form-component', ProductFormComponent);
// }

// class FlyToCart extends HTMLElement {
//   source = null;
//   sourceRect = null;
//   destination = null;

//   connectedCallback() {
//     this.style.pointerEvents = 'none';
//     this.style.position = 'fixed';
//     this.style.zIndex = '2147483647';

//     customCartAnimationLock = true;

//     if (customCartAnimationUnlockTimer) {
//       clearTimeout(customCartAnimationUnlockTimer);
//     }

//     customCartAnimationUnlockTimer = window.setTimeout(() => {
//       customCartAnimationLock = false;
//       customCartAnimationUnlockTimer = null;
//       if (this.isConnected) this.remove();
//     }, 1200);

//     this.#animate();
//   }

//   #animate() {
//     if (!this.destination) {
//       customCartAnimationLock = false;
//       if (customCartAnimationUnlockTimer) {
//         clearTimeout(customCartAnimationUnlockTimer);
//         customCartAnimationUnlockTimer = null;
//       }
//       this.remove();
//       return;
//     }

//     const rect = this.getBoundingClientRect();
//     const destinationRect = this.destination.getBoundingClientRect();

//     let sourceRect;

//     if (this.sourceRect) {
//       sourceRect = this.sourceRect;
//     } else if (this.source instanceof Element) {
//       const liveRect = this.source.getBoundingClientRect();
//       sourceRect = {
//         left: liveRect.left,
//         top: liveRect.top,
//         width: liveRect.width,
//         height: liveRect.height,
//       };
//     } else {
//       customCartAnimationLock = false;
//       if (customCartAnimationUnlockTimer) {
//         clearTimeout(customCartAnimationUnlockTimer);
//         customCartAnimationUnlockTimer = null;
//       }
//       this.remove();
//       return;
//     }

//     const offset = {
//       x: rect.width / 2,
//       y: rect.height / 2,
//     };

//     const startPoint = {
//       x: sourceRect.left + sourceRect.width / 2 - offset.x,
//       y: sourceRect.top + sourceRect.height / 2 - offset.y,
//     };

//     const endPoint = {
//       x: destinationRect.left + destinationRect.width / 2 - offset.x,
//       y: destinationRect.top + destinationRect.height / 2 - offset.y,
//     };

//     const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 };
//     const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 };

//     let startTime = null;
//     const duration = 600;

//     this.style.opacity = '1';
//     this.style.setProperty('--x', `${startPoint.x}px`);
//     this.style.setProperty('--y', `${startPoint.y}px`);

//     const animate = (currentTime) => {
//       if (!startTime) startTime = currentTime;
//       const elapsed = currentTime - startTime;
//       const progress = Math.min(elapsed / duration, 1);

//       const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

//       this.style.setProperty('--x', `${position.x}px`);
//       this.style.setProperty('--y', `${position.y}px`);

//       const scale = 1 - progress * 0.5;
//       this.style.setProperty('--scale', `${scale}`);

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         this.style.opacity = '0';

//         setTimeout(() => {
//           customCartAnimationLock = false;
//           if (customCartAnimationUnlockTimer) {
//             clearTimeout(customCartAnimationUnlockTimer);
//             customCartAnimationUnlockTimer = null;
//           }
//           if (this.isConnected) this.remove();
//         }, 120);
//       }
//     };

//     requestAnimationFrame(animate);
//   }
// }

// /**
//  * Calculates a point on a cubic Bézier curve.
//  * @param {number} t
//  * @param {{x: number, y: number}} p0
//  * @param {{x: number, y: number}} p1
//  * @param {{x: number, y: number}} p2
//  * @param {{x: number, y: number}} p3
//  * @returns {{x: number, y: number}}
//  */
// function bezierPoint(t, p0, p1, p2, p3) {
//   const cX = 3 * (p1.x - p0.x);
//   const bX = 3 * (p2.x - p1.x) - cX;
//   const aX = p3.x - p0.x - cX - bX;

//   const cY = 3 * (p1.y - p0.y);
//   const bY = 3 * (p2.y - p1.y) - cY;
//   const aY = p3.y - p0.y - cY - bY;

//   const x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x;
//   const y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y;

//   return { x, y };
// }

// if (!customElements.get('fly-to-cart')) {
//   customElements.define('fly-to-cart', FlyToCart);
// }

// ################################修复右上角购物车icon图标########################################################################

import { Component } from '@theme/component';
import { fetchConfig, onAnimationEnd, preloadImage } from '@theme/utilities';
import { ThemeEvents, CartAddEvent, CartErrorEvent, CartUpdateEvent, VariantUpdateEvent } from '@theme/events';
import { cartPerformance } from '@theme/performance';
import { morph } from '@theme/morph';

export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;

const ERROR_MESSAGE_DISPLAY_DURATION = 10000;
const ERROR_BUTTON_REENABLE_DELAY = 1000;
const SUCCESS_MESSAGE_DISPLAY_DURATION = 5000;

// =========================
// 自定义：购物车徽标与飞入动画配置
// =========================
const CUSTOM_CART_COUNT_STORAGE_KEY = 'custom_cart_click_count_v2';
const CUSTOM_CART_ICON_SELECTORS = [
  '[data-cart-icon]'
];

let customLastAddToCartSourceElement = null;
let customLastAddToCartSourceRect = null;
let customCartAnimationLock = false;
let customCartAnimationUnlockTimer = null;
let customCartUiInitialized = false;
let customLastSuccessSignature = '';
let customLastSuccessAt = 0;

/**
 * 获取 localStorage 数量
 * @returns {number}
 */
function getCustomStoredCartCount() {
  try {
    const raw = localStorage.getItem(CUSTOM_CART_COUNT_STORAGE_KEY);
    const num = parseInt(raw || '0', 10);
    return Number.isNaN(num) ? 0 : Math.max(0, num);
  } catch (e) {
    return 0;
  }
}

/**
 * 设置 localStorage 数量
 * @param {number} value
 */
function setCustomStoredCartCount(value) {
  try {
    localStorage.setItem(CUSTOM_CART_COUNT_STORAGE_KEY, String(Math.max(0, value)));
  } catch (e) {}
}

/**
 * 增加 localStorage 数量
 * @param {number} step
 * @returns {number}
 */
function incrementCustomStoredCartCount(step = 1) {
  const current = getCustomStoredCartCount();
  const next = current + Math.max(1, step);
  setCustomStoredCartCount(next);
  return next;
}

/**
 * 清空 localStorage 数量
 */
function clearCustomStoredCartCount() {
  try {
    localStorage.removeItem(CUSTOM_CART_COUNT_STORAGE_KEY);
  } catch (e) {}
}

/**
 * 是否购物车页
 * @returns {boolean}
 */
function isCustomCartPage() {
  return window.location.pathname === '/cart';
}

/**
 * 获取所有购物车 icon
 * @returns {Element[]}
 */
function getAllCustomCartIcons() {
  const found = [];
  const seen = new Set();

  CUSTOM_CART_ICON_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (!seen.has(el)) {
        seen.add(el);
        found.push(el);
      }
    });
  });

  return found;
}

/**
 * 获取当前可见购物车 icon
 * @returns {Element | null}
 */
function getVisibleCustomCartIcon() {
  const icons = getAllCustomCartIcons();
  const visible = icons.find((el) => {
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  });
  return visible || icons[0] || null;
}

/**
 * 获取或创建购物车徽标
 * @param {Element} cartIcon
 * @returns {HTMLElement | null}
 */
function getOrCreateCustomCartBadge(cartIcon) {
  if (!(cartIcon instanceof HTMLElement)) return null;

  cartIcon.classList.add('cart-icon-badge-anchor');

  let badge = cartIcon.querySelector('.cart-count-badge--custom');
  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'cart-count-badge--custom is-hidden';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = '0';
    cartIcon.appendChild(badge);
  }

  return /** @type {HTMLElement} */ (badge);
}

/**
 * 更新所有购物车徽标
 * @param {number} count
 */
function updateAllCustomCartBadges(count) {
  const icons = getAllCustomCartIcons();
  icons.forEach((icon) => {
    const badge = getOrCreateCustomCartBadge(icon);
    if (!badge) return;

    badge.textContent = count > 99 ? '99+' : String(count);

    if (count > 0) {
      badge.classList.remove('is-hidden');
    } else {
      badge.classList.add('is-hidden');
    }
  });
}

/**
 * 从 localStorage 同步徽标
 */
function syncCustomCartBadgesFromStorage() {
  updateAllCustomCartBadges(getCustomStoredCartCount());
}

/**
 * 从真实 cart 同步徽标
 */
async function syncCustomCartBadgesFromCart() {
  try {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }

    const cart = await response.json();
    const actualCount = Number(cart.item_count) || 0;

    setCustomStoredCartCount(actualCount);
    updateAllCustomCartBadges(actualCount);

    return actualCount;
  } catch (error) {
    syncCustomCartBadgesFromStorage();
    return getCustomStoredCartCount();
  }
}

/**
 * 清空徽标显示
 */
function clearCustomCartBadgesImmediately() {
  updateAllCustomCartBadges(0);
}

/**
 * 购物车图标抖动
 * @param {Element | null} cartIcon
 */
function bounceCustomCartIcon(cartIcon) {
  if (!(cartIcon instanceof HTMLElement)) return;

  cartIcon.classList.remove('cart-icon-bounce');
  void cartIcon.offsetWidth;
  cartIcon.classList.add('cart-icon-bounce');

  setTimeout(() => {
    cartIcon.classList.remove('cart-icon-bounce');
  }, 700);
}

/**
 * 确保样式只注入一次
 */
function ensureCustomCartUiStyles() {
  if (document.getElementById('custom-cart-badge-styles')) return;

  const style = document.createElement('style');
  style.id = 'custom-cart-badge-styles';
  style.textContent = `
    .cart-icon-badge-anchor {
      position: relative !important;
      overflow: visible !important;
    }

    .cart-count-badge--custom {
      position: absolute;
      top: -8px;
      right: -12px;
      min-width: 22px;
      height: 22px;
      padding: 0 6px;
      border-radius: 999px;
      background: #e3a23a;
      color: #fff;
      font-size: 12px;
      line-height: 22px;
      font-weight: 700;
      text-align: center;
      white-space: nowrap;
      box-shadow: 0 4px 10px rgba(227, 162, 58, 0.28);
      border: 2px solid #fff;
      z-index: 999;
      pointer-events: none;
    }

    .cart-count-badge--custom.is-hidden {
      display: none;
    }

    .cart-icon-bounce {
      animation: cartIconBounce 0.62s ease;
    }

    @keyframes cartIconBounce {
      0% { transform: scale(1); }
      25% { transform: scale(1.16); }
      50% { transform: scale(0.94); }
      75% { transform: scale(1.08); }
      100% { transform: scale(1); }
    }

    fly-to-cart,
    fly-to-cart * {
      pointer-events: none !important;
    }

    fly-to-cart {
      position: fixed !important;
      z-index: 2147483647 !important;
    }

    @media (max-width: 749px) {
      .cart-count-badge--custom {
        top: -6px;
        right: -10px;
      }
    }
  `;
  document.head.appendChild(style);
}

/**
 * 初始化购物车 UI 事件
 */
function initializeCustomCartUiOnce() {
  if (customCartUiInitialized) return;
  customCartUiInitialized = true;

  ensureCustomCartUiStyles();

  syncCustomCartBadgesFromStorage();
  setTimeout(syncCustomCartBadgesFromStorage, 60);

  syncCustomCartBadgesFromCart();
  setTimeout(syncCustomCartBadgesFromCart, 300);
  setTimeout(syncCustomCartBadgesFromCart, 1200);

  document.addEventListener(
    'click',
    (event) => {
      const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
      if (!target) return;

      const cartHit = target.closest(CUSTOM_CART_ICON_SELECTORS.join(', '));

      if (cartHit) {
        setTimeout(() => {
          syncCustomCartBadgesFromCart();
        }, 50);
      }
    },
    true
  );

  window.addEventListener('storage', (event) => {
    if (event.key === CUSTOM_CART_COUNT_STORAGE_KEY) {
      if (isCustomCartPage()) {
        clearCustomStoredCartCount();
        clearCustomCartBadgesImmediately();
      } else {
        syncCustomCartBadgesFromStorage();
      }
    }
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(syncCustomCartBadgesFromCart, 100);
  });

  document.addEventListener('shopify:section:reorder', () => {
    setTimeout(syncCustomCartBadgesFromCart, 100);
  });

  document.addEventListener('shopify:block:select', () => {
    setTimeout(syncCustomCartBadgesFromCart, 100);
  });
}

/**
 * 从 source 飞向 cart
 * @param {Element | null | undefined} source
 * @param {Element | null | undefined} destination
 */
function runCustomFlyToCart(source, destination) {
  const cartIcon = destination || getVisibleCustomCartIcon();

  if (!cartIcon) return;

  if (customCartAnimationLock) {
    bounceCustomCartIcon(cartIcon);
    return;
  }

  const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));

  if (source instanceof Element) {
    flyToCartElement.source = source;
  }

  if (customLastAddToCartSourceRect) {
    flyToCartElement.sourceRect = customLastAddToCartSourceRect;
  }

  flyToCartElement.destination = cartIcon;
  document.body.appendChild(flyToCartElement);
}

/**
 * 加购成功后的统一处理
 * @param {number} quantityToAdd
 * @param {Element | null | undefined} sourceElement
 * @param {string} variantId
 */
function handleCustomAddSuccess(quantityToAdd, sourceElement, variantId = '') {
  initializeCustomCartUiOnce();

  const now = Date.now();
  const rect = customLastAddToCartSourceRect;
  const rectKey = rect
    ? `${Math.round(rect.left)}-${Math.round(rect.top)}-${Math.round(rect.width)}-${Math.round(rect.height)}`
    : 'no-rect';

  const successSignature = `${variantId || 'no-variant'}|${quantityToAdd}|${rectKey}`;

  if (customLastSuccessSignature === successSignature && now - customLastSuccessAt < 450) {
    return;
  }

  customLastSuccessSignature = successSignature;
  customLastSuccessAt = now;

  const nextCount = incrementCustomStoredCartCount(quantityToAdd);
  updateAllCustomCartBadges(nextCount);

  const cartIcon = getVisibleCustomCartIcon();
  runCustomFlyToCart(sourceElement || customLastAddToCartSourceElement, cartIcon);

  setTimeout(syncCustomCartBadgesFromCart, 120);
  setTimeout(syncCustomCartBadgesFromCart, 400);
  setTimeout(syncCustomCartBadgesFromCart, 900);
  setTimeout(syncCustomCartBadgesFromCart, 1500);
}

function rememberCustomAddSource(sourceElement) {
  if (!(sourceElement instanceof Element)) return;

  customLastAddToCartSourceElement = sourceElement;

  const rect = sourceElement.getBoundingClientRect();
  customLastAddToCartSourceRect = {
    left: rect.left,
    top: rect.top,
    width: rect.width,
    height: rect.height,
  };
}

async function addCustomUpsellItem({
  variantId,
  quantity = 1,
  sourceElement = null,
  sections = '',
}) {
  if (!variantId) {
    throw new Error('Upsell add to cart requires a variantId');
  }

  initializeCustomCartUiOnce();

  if (sourceElement instanceof Element) {
    rememberCustomAddSource(sourceElement);
  }

  const formData = new FormData();
  formData.append('id', String(variantId));
  formData.append('quantity', String(Math.max(1, Number(quantity) || 1)));

  if (sections) {
    formData.append('sections', sections);
  }

  const response = await fetch(Theme.routes.cart_add_url || '/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok || data.status) {
    throw new Error(data.description || data.message || 'Failed to add upsell item to cart');
  }

  handleCustomAddSuccess(
    Math.max(1, Number(quantity) || 1),
    sourceElement || customLastAddToCartSourceElement,
    String(variantId)
  );

  return data;
}

window.CustomUpsellCart = window.CustomUpsellCart || {
  rememberSource: rememberCustomAddSource,
  handleSuccess: handleCustomAddSuccess,
  addItem: addCustomUpsellItem,
  init: initializeCustomCartUiOnce,
  syncBadge: syncCustomCartBadgesFromCart,
};

export class AddToCartComponent extends Component {
  requiredRefs = ['addToCartButton'];

  #animationTimeout;
  #cleanupTimeout;

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('pointerenter', this.#preloadImage);
    this.addEventListener('pointerdown', this.#rememberSource, true);

    initializeCustomCartUiOnce();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
    if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);
    this.removeEventListener('pointerenter', this.#preloadImage);
    this.removeEventListener('pointerdown', this.#rememberSource, true);
  }

  disable() {
    this.refs.addToCartButton.disabled = true;
  }

  enable() {
    this.refs.addToCartButton.disabled = false;
  }

  #rememberSource = (event) => {
    const target = /** @type {HTMLElement | null} */ (event.target instanceof HTMLElement ? event.target : null);
    if (!target) return;

    const button =
      target.closest('button') ||
      this.refs.addToCartButton ||
      this;

    customLastAddToCartSourceElement = button;

    if (button instanceof Element) {
      const rect = button.getBoundingClientRect();
      customLastAddToCartSourceRect = {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
      };
    }
  };

  handleClick(event) {
    const form = this.closest('form');
    if (!form?.checkValidity()) return;

    const quantitySelector = /** @type {any} */ (form.querySelector('quantity-selector-component'));
    if (quantitySelector?.canAddToCart) {
      const validation = quantitySelector.canAddToCart();
      if (!validation.canAdd) {
        return;
      }
    }

    this.animateAddToCart();

    customLastAddToCartSourceElement =
      event.target.closest('button') ||
      this.refs.addToCartButton ||
      this;

    if (customLastAddToCartSourceElement instanceof Element) {
      const rect = customLastAddToCartSourceElement.getBoundingClientRect();
      customLastAddToCartSourceRect = {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
      };
    }
  }

  #preloadImage = () => {
    const image = this.dataset.productVariantMedia;
    if (!image) return;
    preloadImage(image);
  };

  animateAddToCart() {
    const { addToCartButton } = this.refs;

    if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
    if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);

    if (!addToCartButton.classList.contains('atc-added')) {
      addToCartButton.classList.add('atc-added');
    }

    this.#animationTimeout = setTimeout(() => {
      this.#cleanupTimeout = setTimeout(() => {
        this.refs.addToCartButton.classList.remove('atc-added');
      }, 10);
    }, ADD_TO_CART_TEXT_ANIMATION_DURATION);
  }
}

if (!customElements.get('add-to-cart-component')) {
  customElements.define('add-to-cart-component', AddToCartComponent);
}

class ProductFormComponent extends Component {
  requiredRefs = ['variantId', 'liveRegion'];
  #abortController = new AbortController();
  #timeout;

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
    target?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected, { signal });

    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate, { signal });

    initializeCustomCartUiOnce();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  async #fetchAndUpdateCartQuantity() {
    const variantIdInput = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="id"]'));
    if (!variantIdInput?.value) return 0;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartItem = cart.items.find(
        (item) => item.variant_id.toString() === variantIdInput.value.toString()
      );
      const cartQty = cartItem ? cartItem.quantity : 0;

      const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
      if (quantitySelector?.setCartQuantity) {
        quantitySelector.setCartQuantity(cartQty);
      }

      this.#updateQuantityLabel(cartQty);

      return cartQty;
    } catch (error) {
      console.error('Failed to fetch cart quantity:', error);
      return 0;
    }
  }

  #onCartUpdate = async (event) => {
    if (event.detail?.sourceId === this.id || event.detail?.data?.source === 'product-form-component') return;
    await this.#fetchAndUpdateCartQuantity();
  };

  handleSubmit(event) {
    const { addToCartTextError, addToCartButtonContainer } = this.refs;
    event.preventDefault();

    if (this.#timeout) clearTimeout(this.#timeout);
    if (addToCartButtonContainer?.refs.addToCartButton?.disabled) return;

    const form = this.querySelector('form');
    if (!form) throw new Error('Product form element missing');

    const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
    if (quantitySelector?.canAddToCart) {
      const validation = quantitySelector.canAddToCart();

      if (!validation.canAdd) {
        addToCartButtonContainer?.disable();

        const errorTemplate = this.dataset.quantityErrorMax || '';
        const errorMessage = errorTemplate.replace('{{ maximum }}', validation.maxQuantity.toString());
        if (addToCartTextError) {
          addToCartTextError.classList.remove('hidden');

          const textNode = addToCartTextError.childNodes[2];
          if (textNode) {
            textNode.textContent = errorMessage;
          } else {
            const newTextNode = document.createTextNode(errorMessage);
            addToCartTextError.appendChild(newTextNode);
          }

          this.#setLiveRegionText(errorMessage);

          if (this.#timeout) clearTimeout(this.#timeout);
          this.#timeout = setTimeout(() => {
            if (!addToCartTextError) return;
            addToCartTextError.classList.add('hidden');
            this.#clearLiveRegionText();
          }, ERROR_MESSAGE_DISPLAY_DURATION);
        }

        setTimeout(() => {
          addToCartButtonContainer?.enable();
        }, ERROR_BUTTON_REENABLE_DELAY);

        return;
      }
    }

    const formData = new FormData(form);
    const quantityRaw = formData.get('quantity');
    const quantityToAdd = Number(quantityRaw) || Number(this.dataset.quantityDefault) || 1;

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    let cartItemComponentsSectionIds = [];
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        cartItemComponentsSectionIds.push(item.dataset.sectionId);
      }
      formData.append('sections', cartItemComponentsSectionIds.join(','));
    });

    const fetchCfg = fetchConfig('javascript', { body: formData });

    fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'text/html',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.dispatchEvent(
            new CartErrorEvent(form.getAttribute('id') || '', response.message, response.description, response.errors)
          );

          if (!addToCartTextError) return;
          addToCartTextError.classList.remove('hidden');

          const textNode = addToCartTextError.childNodes[2];
          if (textNode) {
            textNode.textContent = response.message;
          } else {
            const newTextNode = document.createTextNode(response.message);
            addToCartTextError.appendChild(newTextNode);
          }

          this.#setLiveRegionText(response.message);

          this.#timeout = setTimeout(() => {
            if (!addToCartTextError) return;
            addToCartTextError.classList.add('hidden');
            this.#clearLiveRegionText();
          }, ERROR_MESSAGE_DISPLAY_DURATION);

          this.dispatchEvent(
            new CartAddEvent({}, this.id, {
              didError: true,
              source: 'product-form-component',
              itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
              productId: this.dataset.productId,
            })
          );

          return;
        } else {
          const id = formData.get('id');

          if (addToCartTextError) {
            addToCartTextError.classList.add('hidden');
            addToCartTextError.removeAttribute('aria-live');
          }

          if (!id) throw new Error('Form ID is required');

          if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
            const addToCartButton = this.refs.addToCartButtonContainer.refs.addToCartButton;
            const addedTextElement = addToCartButton.querySelector('.add-to-cart-text--added');
            const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;

            this.#setLiveRegionText(addedText);

            setTimeout(() => {
              this.#clearLiveRegionText();
            }, SUCCESS_MESSAGE_DISPLAY_DURATION);
          }

          handleCustomAddSuccess(
            quantityToAdd,
            customLastAddToCartSourceElement,
            id ? id.toString() : ''
          );

          this.#fetchAndUpdateCartQuantity();

          this.dispatchEvent(
            new CartAddEvent({}, id.toString(), {
              source: 'product-form-component',
              itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
              productId: this.dataset.productId,
              sections: response.sections,
            })
          );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        cartPerformance.measureFromEvent('add:user-action', event);
      });
  }

  #updateQuantityLabel(cartQty) {
    const quantityLabel = this.refs.quantityLabelCartCount;
    if (quantityLabel) {
      const inCartText = quantityLabel.textContent?.match(/\((\d+)\s+(.+)\)/);
      if (inCartText && inCartText[2]) {
        quantityLabel.textContent = `(${cartQty} ${inCartText[2]})`;
      }

      quantityLabel.classList.toggle('hidden', cartQty === 0);
    }
  }

  #setLiveRegionText(text) {
    const liveRegion = this.refs.liveRegion;
    liveRegion.textContent = text;
  }

  #clearLiveRegionText() {
    const liveRegion = this.refs.liveRegion;
    liveRegion.textContent = '';
  }

  #morphOrUpdateElement(currentElement, newElement, insertReferenceElement = null) {
    if (currentElement && newElement) {
      morph(currentElement, newElement);
    } else if (currentElement && !newElement) {
      currentElement.remove();
    } else if (!currentElement && newElement && insertReferenceElement) {
      insertReferenceElement.insertAdjacentElement('beforebegin', /** @type {Element} */ (newElement.cloneNode(true)));
    }
  }

  #onVariantUpdate = async (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const { variantId, addToCartButtonContainer } = this.refs;

    const currentAddToCartButton = addToCartButtonContainer?.refs.addToCartButton;
    const newAddToCartButton = event.detail.data.html.querySelector('[ref="addToCartButton"]');

    variantId.value = event.detail.resource?.id ?? '';

    if (!currentAddToCartButton && !this.refs.acceleratedCheckoutButtonContainer) return;

    if (currentAddToCartButton) {
      if (event.detail.resource == null || event.detail.resource.available == false) {
        addToCartButtonContainer.disable();
      } else {
        addToCartButtonContainer.enable();
      }

      if (newAddToCartButton) {
        morph(currentAddToCartButton, newAddToCartButton);
      }
    }

    if (this.refs.acceleratedCheckoutButtonContainer) {
      if (event.detail.resource == null || event.detail.resource.available == false) {
        this.refs.acceleratedCheckoutButtonContainer?.setAttribute('hidden', 'true');
      } else {
        this.refs.acceleratedCheckoutButtonContainer?.removeAttribute('hidden');
      }
    }

    if (event.detail.resource) {
      const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
      productVariantMedia &&
        addToCartButtonContainer?.setAttribute('data-product-variant-media', productVariantMedia + '&width=100');
    }

    const quantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
    const newQuantityInput = /** @type {HTMLInputElement | null} */ (
      event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
    );

    if (quantitySelector?.updateConstraints && newQuantityInput) {
      quantitySelector.updateConstraints(
        newQuantityInput.min,
        newQuantityInput.max || null,
        newQuantityInput.step
      );
    }

    const quantityRules = this.refs.quantityRules;
    const newQuantityRules = event.detail.data.html.querySelector('.quantity-rules');
    const isQuantityRulesChanging = !!quantityRules !== !!newQuantityRules;

    if (isQuantityRulesChanging && quantitySelector) {
      const currentQuantityValue = quantitySelector.getValue?.();

      const currentProductFormButtons = this.refs.productFormButtons;
      const newProductFormButtons = event.detail.data.html.querySelector('.product-form-buttons');

      if (currentProductFormButtons && newProductFormButtons) {
        morph(currentProductFormButtons, newProductFormButtons);

        const newQuantitySelector = /** @type {any} */ (this.querySelector('quantity-selector-component'));
        const newQuantityInputElement = /** @type {HTMLInputElement | null} */ (
          event.detail.data.html.querySelector('quantity-selector-component input[ref="quantityInput"]')
        );

        if (newQuantitySelector?.updateConstraints && newQuantityInputElement && currentQuantityValue) {
          newQuantitySelector.setValue(currentQuantityValue);
          newQuantitySelector.updateConstraints(
            newQuantityInputElement.min,
            newQuantityInputElement.max || null,
            newQuantityInputElement.step
          );
        }
      }
    } else {
      const quantityLabel = this.querySelector('.quantity-label');
      const newQuantityLabel = event.detail.data.html.querySelector('.quantity-label');
      this.#morphOrUpdateElement(quantityLabel, newQuantityLabel, quantitySelector);

      const addToCartButton = this.querySelector('[ref="addToCartButtonContainer"]');
      this.#morphOrUpdateElement(quantityRules, newQuantityRules, addToCartButton);
    }

    await this.#fetchAndUpdateCartQuantity();
  };

  #onVariantSelected = () => {
    this.refs.addToCartButtonContainer?.disable();
  };
}

if (!customElements.get('product-form-component')) {
  customElements.define('product-form-component', ProductFormComponent);
}

class FlyToCart extends HTMLElement {
  source = null;
  sourceRect = null;
  destination = null;

  connectedCallback() {
    this.style.pointerEvents = 'none';
    this.style.position = 'fixed';
    this.style.zIndex = '2147483647';

    customCartAnimationLock = true;

    if (customCartAnimationUnlockTimer) {
      clearTimeout(customCartAnimationUnlockTimer);
    }

    customCartAnimationUnlockTimer = window.setTimeout(() => {
      customCartAnimationLock = false;
      customCartAnimationUnlockTimer = null;
      if (this.isConnected) this.remove();
    }, 1200);

    this.#animate();
  }

  #animate() {
    if (!this.destination) {
      customCartAnimationLock = false;
      if (customCartAnimationUnlockTimer) {
        clearTimeout(customCartAnimationUnlockTimer);
        customCartAnimationUnlockTimer = null;
      }
      this.remove();
      return;
    }

    const rect = this.getBoundingClientRect();
    const destinationRect = this.destination.getBoundingClientRect();

    let sourceRect;

    if (this.sourceRect) {
      sourceRect = this.sourceRect;
    } else if (this.source instanceof Element) {
      const liveRect = this.source.getBoundingClientRect();
      sourceRect = {
        left: liveRect.left,
        top: liveRect.top,
        width: liveRect.width,
        height: liveRect.height,
      };
    } else {
      customCartAnimationLock = false;
      if (customCartAnimationUnlockTimer) {
        clearTimeout(customCartAnimationUnlockTimer);
        customCartAnimationUnlockTimer = null;
      }
      this.remove();
      return;
    }

    const offset = {
      x: rect.width / 2,
      y: rect.height / 2,
    };

    const startPoint = {
      x: sourceRect.left + sourceRect.width / 2 - offset.x,
      y: sourceRect.top + sourceRect.height / 2 - offset.y,
    };

    const endPoint = {
      x: destinationRect.left + destinationRect.width / 2 - offset.x,
      y: destinationRect.top + destinationRect.height / 2 - offset.y,
    };

    const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 };
    const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 };

    let startTime = null;
    const duration = 600;

    this.style.opacity = '1';
    this.style.setProperty('--x', `${startPoint.x}px`);
    this.style.setProperty('--y', `${startPoint.y}px`);

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

      this.style.setProperty('--x', `${position.x}px`);
      this.style.setProperty('--y', `${position.y}px`);

      const scale = 1 - progress * 0.5;
      this.style.setProperty('--scale', `${scale}`);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.style.opacity = '0';

        setTimeout(() => {
          customCartAnimationLock = false;
          if (customCartAnimationUnlockTimer) {
            clearTimeout(customCartAnimationUnlockTimer);
            customCartAnimationUnlockTimer = null;
          }
          if (this.isConnected) this.remove();
        }, 120);
      }
    };

    requestAnimationFrame(animate);
  }
}

/**
 * Calculates a point on a cubic Bézier curve.
 * @param {number} t
 * @param {{x: number, y: number}} p0
 * @param {{x: number, y: number}} p1
 * @param {{x: number, y: number}} p2
 * @param {{x: number, y: number}} p3
 * @returns {{x: number, y: number}}
 */
function bezierPoint(t, p0, p1, p2, p3) {
  const cX = 3 * (p1.x - p0.x);
  const bX = 3 * (p2.x - p1.x) - cX;
  const aX = p3.x - p0.x - cX - bX;

  const cY = 3 * (p1.y - p0.y);
  const bY = 3 * (p2.y - p1.y) - cY;
  const aY = p3.y - p0.y - cY - bY;

  const x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + p0.x;
  const y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + p0.y;

  return { x, y };
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}